const Dummy = {
  product: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="60"
      height="78"
      fill="none"
      viewBox="0 0 60 78"
    >
      <rect width="60" height="78" fill="url(#pattern0)" rx="6"></rect>
      <defs>
        <pattern id="pattern0" width="1" height="1" patternContentUnits="objectBoundingBox">
          <use transform="scale(.004 .00308)" xlinkHref="#image0_501_12836"></use>
        </pattern>
        <image
          id="image0_501_12836"
          width="250"
          height="325"
          xlinkHref="data:image/png;base64,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"
        ></image>
      </defs>
    </svg>
  ),
  beads: (
    <svg xmlns="http://www.w3.org/2000/svg" width="58" height="126" fill="none" viewBox="0 0 58 126">
      <path
        fill="#248AE6"
        d="M.024 6.744c2.553 0 4.619 2.18 4.619 4.865s-2.07 4.865-4.619 4.865H0v7.401h.024c2.553 0 4.619 2.18 4.619 4.865s-2.07 4.864-4.619 4.864H0v7.402h.021c2.553 0 4.619 2.18 4.619 4.865S2.57 50.735.02 50.735H0v7.402h.021c2.553 0 4.619 2.18 4.619 4.865S2.57 67.866.02 67.866H0v7.402h.021c2.553 0 4.619 2.18 4.619 4.864 0 2.686-2.07 4.865-4.619 4.865H0V92.4h.018c2.553 0 4.619 2.18 4.619 4.864 0 2.685-2.07 4.865-4.619 4.865H0v7.402h.018c2.553 0 4.619 2.179 4.619 4.864s-2.07 4.865-4.619 4.865H0V128h271v-8.751c-2.552 0-4.618-2.179-4.618-4.864s2.066-4.865 4.618-4.865v-7.398c-2.552 0-4.618-2.18-4.618-4.865s2.066-4.868 4.618-4.868v-7.398c-2.552 0-4.618-2.18-4.618-4.865s2.069-4.865 4.618-4.865v-7.398c-2.549 0-4.618-2.18-4.618-4.865s2.066-4.864 4.618-4.864v-7.399c-2.549 0-4.615-2.18-4.615-4.864 0-2.685 2.066-4.865 4.615-4.865v-7.398c-2.549 0-4.615-2.18-4.615-4.865s2.066-4.861 4.615-4.865V16.48c-2.549 0-4.612-2.18-4.612-4.865s2.066-4.861 4.612-4.864V-2H0v8.754h.024v-.01z"
      ></path>
    </svg>
  ),
  product_sm: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="49"
      height="48"
      fill="none"
      viewBox="0 0 49 48"
    >
      <rect width="48" height="48" x="0.75" fill="url(#pattern0)" rx="4"></rect>
      <defs>
        <pattern id="pattern0" width="1" height="1" patternContentUnits="objectBoundingBox">
          <use transform="matrix(.00308 0 0 .00308 .115 0)" xlinkHref="#image0_283_13584"></use>
        </pattern>
        <image
          id="image0_283_13584"
          width="250"
          height="325"
          xlinkHref="data:image/png;base64,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"
        ></image>
      </defs>
    </svg>
  ),
  test_product: "blob:http://localhost:3000/a7b8d426-b78a-41bd-9dbe-d5d17928b32a",
  iphone: (
    <svg xmlns="http://www.w3.org/2000/svg" width={270} height={540} fill="none" viewBox="0 0 180 368">
      <path
        fill="#303030"
        d="M178.455 94.137h.637a.64.64 0 0 1 .637.642v41.934a.64.64 0 0 1-.637.642h-.637V94.137ZM1.274 146.341H.637a.64.64 0 0 1-.637-.642v-25.246a.64.64 0 0 1 .637-.642h.637v26.53Z"
      />
      <path
        fill="#333"
        d="M1.274 111.253H.637a.64.64 0 0 1-.637-.642V85.365a.64.64 0 0 1 .637-.642h.637v26.53ZM1.274 71.887H.637A.64.64 0 0 1 0 71.245v-12.41a.64.64 0 0 1 .637-.641h.637v13.693Z"
      />
      <path
        fill="#333"
        fillRule="evenodd"
        d="M2.626 19.218c-1.352 4.19-1.352 9.367-1.352 19.72v289.259c0 10.354 0 15.531 1.352 19.721 2.732 8.467 9.324 15.106 17.732 17.857 4.16 1.361 9.3 1.361 19.581 1.361h99.85c10.281 0 15.421 0 19.581-1.361 8.408-2.751 15-9.39 17.732-17.857 1.352-4.19 1.352-9.367 1.352-19.721V38.939c0-10.354 0-15.53-1.352-19.72-2.732-8.468-9.324-15.106-17.732-17.858C155.21 0 150.07 0 139.789 0h-99.85C29.66 0 24.518 0 20.358 1.361c-8.408 2.752-15 9.39-17.732 17.857Zm43.687-8.735v1.926h.03l-.03.214c0 5.08 4.09 9.2 9.135 9.2h68.832c5.046 0 9.136-4.12 9.136-9.2l-.031-.215.03.001v-1.926c0-1.3 1.047-2.353 2.337-2.353h5.473c8.556 0 12.833 0 16.245 1.298a20.039 20.039 0 0 1 11.622 11.704c1.289 3.436 1.289 7.744 1.289 16.36v292.152c0 8.616 0 12.924-1.289 16.36a20.04 20.04 0 0 1-11.622 11.704c-3.412 1.298-7.689 1.298-16.245 1.298H38.503c-8.555 0-12.833 0-16.245-1.298a20.043 20.043 0 0 1-11.621-11.704c-1.29-3.436-1.29-7.744-1.29-16.36V37.492c0-8.616 0-12.924 1.29-16.36A20.041 20.041 0 0 1 22.258 9.428C25.67 8.13 29.948 8.13 38.503 8.13h5.473a2.345 2.345 0 0 1 2.337 2.353Z"
        clipRule="evenodd"
      />
      <path
        fill="#303030"
        fillRule="evenodd"
        d="M139.959.856H39.769C29.613.856 24.636.86 20.62 2.175c-8.149 2.667-14.538 9.1-17.186 17.308-1.305 4.044-1.31 9.057-1.31 19.284v289.601c0 10.228.005 15.241 1.31 19.285 2.648 8.207 9.037 14.641 17.186 17.308 4.016 1.314 8.993 1.319 19.15 1.319h100.189c10.156 0 15.133-.005 19.149-1.319 8.149-2.667 14.538-9.101 17.186-17.308 1.305-4.044 1.31-9.057 1.31-19.285v-289.6c0-10.228-.005-15.24-1.31-19.285-2.648-8.207-9.037-14.641-17.186-17.308-4.016-1.314-8.993-1.32-19.149-1.32ZM3.029 19.35C1.7 23.476 1.7 28.573 1.7 38.767v289.601c0 10.195 0 15.292 1.33 19.417 2.69 8.337 9.181 14.874 17.46 17.583 4.096 1.34 9.157 1.34 19.28 1.34h100.19c10.122 0 15.184 0 19.28-1.34 8.279-2.709 14.769-9.246 17.459-17.583 1.331-4.125 1.331-9.222 1.331-19.417v-289.6c0-10.195 0-15.292-1.331-19.417-2.69-8.338-9.18-14.874-17.459-17.583-4.096-1.34-9.158-1.34-19.28-1.34H39.769c-10.122 0-15.184 0-19.28 1.34-8.279 2.709-14.77 9.245-17.46 17.583Z"
        clipRule="evenodd"
      />
      <path
        fill="#121515"
        fillRule="evenodd"
        d="M4.647 19.88C3.4 23.747 3.4 28.526 3.4 38.083v290.97c0 9.558 0 14.336 1.248 18.204 2.522 7.816 8.607 13.944 16.368 16.483 3.84 1.257 8.585 1.257 18.075 1.257H140.64c9.491 0 14.236 0 18.076-1.257 7.761-2.539 13.846-8.667 16.368-16.483 1.247-3.868 1.247-8.646 1.247-18.204V38.083c0-9.557 0-14.336-1.247-18.203-2.522-7.816-8.607-13.944-16.368-16.484-3.84-1.256-8.585-1.256-18.076-1.256H39.09c-9.49 0-14.235 0-18.075 1.256-7.761 2.54-13.846 8.668-16.368 16.484Zm41.666-9.396v1.925h.03l-.03.214c0 5.081 4.09 9.2 9.135 9.2h68.833c5.045 0 9.135-4.119 9.135-9.2l-.031-.215.031.001v-1.925c0-1.3 1.046-2.354 2.337-2.354h5.472c8.556 0 12.834 0 16.245 1.298a20.039 20.039 0 0 1 11.622 11.705c1.29 3.435 1.29 7.744 1.29 16.36v292.151c0 8.616 0 12.924-1.29 16.36a20.04 20.04 0 0 1-11.622 11.704c-3.411 1.298-7.689 1.298-16.245 1.298H38.504c-8.556 0-12.834 0-16.245-1.298a20.043 20.043 0 0 1-11.622-11.704c-1.29-3.436-1.29-7.744-1.29-16.36V37.493c0-8.617 0-12.925 1.29-16.36A20.041 20.041 0 0 1 22.259 9.429C25.67 8.13 29.949 8.13 38.504 8.13h5.472a2.345 2.345 0 0 1 2.337 2.354Z"
        clipRule="evenodd"
      />
      <path
        fill="#414141"
        d="M140.639 0h2.549v2.139h-2.549zM176.33 36.799h2.124v2.567h-2.124zM1.274 36.799h2.124v2.567H1.274zM1.274 327.769h2.124v2.567H1.274zM176.33 327.769h2.124v2.567h-2.124zM36.54 364.997h2.549v2.139H36.54z"
      />
      <path
        fill="#262C2D"
        fillRule="evenodd"
        d="M107.922 17.115c1.877 0 3.399-1.533 3.399-3.423 0-1.89-1.522-3.423-3.399-3.423s-3.399 1.532-3.399 3.423c0 1.89 1.522 3.423 3.399 3.423Z"
        clipRule="evenodd"
      />
      <path
        fill="#121515"
        fillRule="evenodd"
        d="M107.922 15.831a2.132 2.132 0 0 0 2.124-2.14c0-1.18-.951-2.139-2.124-2.139a2.132 2.132 0 0 0-2.125 2.14c0 1.181.951 2.14 2.125 2.14Z"
        clipRule="evenodd"
      />
      <path
        fill="#636F73"
        fillRule="evenodd"
        d="M107.923 13.265a.427.427 0 0 0 .425-.428.427.427 0 0 0-.425-.428.426.426 0 0 0-.425.428c0 .236.19.428.425.428Z"
        clipRule="evenodd"
        opacity={0.4}
      />
      <path
        fill="#262C2D"
        fillRule="evenodd"
        d="M79.455 13.693c0-.71.575-1.284 1.284-1.284H98.99a1.284 1.284 0 1 1 0 2.568H80.74a1.284 1.284 0 0 1-1.284-1.284Z"
        clipRule="evenodd"
      />
    </svg>
  ),
  campaigns: [
    {
      primary_purchase_gtins: ["033383530109"],
      primary_purchase_eans: [],
      deposited: 0,
      providers: ["spectivlabs.thecouponbureau.org"],
      rolling_expiration: 0,
      settled: 0,
      finalized: 0,
      lookupcodes: [],
      allowed_retailers: [],
      settlement_email_sent: 0,
      timezone_val: "Pacific/Honolulu",
      create_date: "2023-10-10",
      internal_id: "9bd719d4",
      approve_date: "2023-10-10",
      offer_code: "793028",
      base_gs1: "811200497900793028",
      email_domain: "spectivlabs.thecouponbureau.org",
      created_by_email_domain: "spectivlabs.thecouponbureau.org",
      brand_id: "bfa28b70",
      description:
        "Get $3.00 off on minimum shopping of 1 unit (5 lb Russet Potatoes) at your nearest store till 17th October 2023",
      campaign_start_time: "2023-10-10",
      campaign_end_time: "2023-10-17",
      redemption_start_time: "2023-10-11",
      redemption_end_time: "2023-10-17",
      total_circulation: 1000,
      primary_purchase_save_value: 300,
      primary_purchase_requirements: 1,
      primary_purchase_req_code: 0,
      save_value_code: 0,
      store_coupon: 0,
      donot_multiply_flag: 1,
      executionId: "6ade3a4d-6cf1-40c3-9914-68091fa4fed8",
      executedByEmail: "148a7d730f1dd0a875aa09f39587c001@spectivlabs.thecouponbureau.org",
      update_datetime: 1696958913952,
      campaign_metadata: {
        allow_override: false,
        title: "Get $3.00 off",
        description:
          "Get $3.00 off on minimum shopping of 1 unit (5 lb Russet Potatoes) at your nearest store till 17th October 2023",
        terms: "https://thecouponbureau.org/terms",
        mobile_image_url:
          "https://gitsy-b2b-dev.s3.ap-south-1.amazonaws.com/01H6R1GGWD5HE1SSX4TKVYA106/product_image/1696931888192.image001%20%281%29.png",
        desktop_image_url:
          "https://gitsy-b2b-dev.s3.ap-south-1.amazonaws.com/01H6R1GGWD5HE1SSX4TKVYA106/product_image/1696931888192.image001%20%281%29.png",
        dollar_amount: 3,
      },
      manufacturer: "spectiv labs",
      brand_name: "Bushmans Inc",
      provider_text: "spectiv labs",
      status: {
        locked: 1,
      },
      access_type: "full_set_with_lock",
      link: "https://gitsyv2app.page.link/SnxrrRbq6nbq8YGz6",
      max_quantity_to_group: "1",
    },
    {
      primary_purchase_gtins: ["036800151673", "036800039735"],
      deposited: 51,
      providers: ["spectivlabs.thecouponbureau.org"],
      rolling_expiration: 0,
      settled: 0,
      finalized: 0,
      lookupcodes: [],
      allowed_retailers: [],
      settlement_email_sent: 0,
      timezone_val: "Pacific/Honolulu",
      create_date: "2023-10-02",
      internal_id: "8584a166",
      approve_date: "2023-10-02",
      offer_code: "581180",
      base_gs1: "811200497900581180",
      email_domain: "spectivlabs.thecouponbureau.org",
      created_by_email_domain: "spectivlabs.thecouponbureau.org",
      brand_id: "c4aabc0c",
      description:
        "Save $3.40 on minimum shopping of 1 unit (Food Club Purified Drinking Water 24 Ea) at your nearest store till 11th October 2023",
      campaign_start_time: "2023-10-01",
      campaign_end_time: "2023-10-11",
      redemption_start_time: "2023-10-04",
      redemption_end_time: "2023-10-11",
      total_circulation: 1000,
      primary_purchase_save_value: 340,
      primary_purchase_requirements: 1,
      primary_purchase_req_code: 0,
      donot_multiply_flag: 1,
      executionId: "1fc2fc81-01bf-494c-86f5-ba3c108efca5",
      executedByEmail: "148a7d730f1dd0a875aa09f39587c001@spectivlabs.thecouponbureau.org",
      update_datetime: 1696572112014,
      campaign_metadata: {
        allow_override: false,
        title: "Save $3.40 ",
        description:
          "Save $3.40 on minimum shopping of 1 unit (Food Club Purified Drinking Water 24 Ea) at your nearest store till 11th October 2023",
        terms: "https://thecouponbureau.org/terms",
        mobile_image_url:
          "https://gitsy-b2b-dev.s3.ap-south-1.amazonaws.com/01H6R1GGWD5HE1SSX4TKVYA106/product_image/1696224077225.e78a781a3118c1f5259fed6cece647f6_large.png",
        desktop_image_url:
          "https://gitsy-b2b-dev.s3.ap-south-1.amazonaws.com/01H6R1GGWD5HE1SSX4TKVYA106/product_image/1696224077225.e78a781a3118c1f5259fed6cece647f6_large.png",
        dollar_amount: 3.4,
      },
      manufacturer: "spectiv labs",
      brand_name: "food club",
      provider_text: "spectiv labs",
      status: {
        locked: 1,
      },
      access_type: "full_set_with_lock",
      link: "https://gitsyv2app.page.link/S7BYSJ1iqQDDhnNBA",
      is_included_in_gallery: true,
      max_quantity_to_group: "1",
      max_limit_to_avail_offer: "Single",
    },
    {
      primary_purchase_gtins: [],
      primary_purchase_eans: ["8901262010016"],
      deposited: 13,
      providers: ["radiansys.thecouponbureau.org", "spectivlabs.thecouponbureau.org"],
      rolling_expiration: 1,
      rolling_expiration_days: 7,
      settled: 0,
      finalized: 0,
      lookupcodes: [],
      allowed_retailers: [],
      settlement_email_sent: 0,
      timezone_val: "Pacific/Honolulu",
      create_date: "2023-09-29",
      internal_id: "d09edd52",
      approve_date: "2023-09-29",
      offer_code: "046491",
      base_gs1: "811200497900046491",
      email_domain: "spectivlabs.thecouponbureau.org",
      created_by_email_domain: "spectivlabs.thecouponbureau.org",
      brand_id: "3de239b9",
      description:
        "Save $3.99 on minimum shopping of 3 units (Amul Pasteurised Butter) at your nearest store till 12th October 2023",
      campaign_start_time: "2023-09-29",
      campaign_end_time: "2023-10-06",
      redemption_start_time: "2023-10-06",
      redemption_end_time: "2023-10-13",
      total_circulation: 1000,
      primary_purchase_save_value: 399,
      primary_purchase_requirements: 3,
      primary_purchase_req_code: 0,
      save_value_code: 0,
      store_coupon: 0,
      donot_multiply_flag: 1,
      executionId: "437b96dc-af43-4e11-a9dd-625a7d7f67ca",
      executedByEmail: "gitsyb2bapikeys_try@spectivlabs.thecouponbureau.org",
      update_datetime: 1696487100736,
      campaign_metadata: {
        allow_override: false,
        title: "Save $3.99 ",
        description:
          "Save $3.99 on minimum shopping of 3 units (Amul Pasteurised Butter) at your nearest store till 12th October 2023",
        terms: "https://thecouponbureau.org/terms",
        mobile_image_url:
          "https://gitsy-b2b-dev.s3.ap-south-1.amazonaws.com/01H6R1GGWD5HE1SSX4TKVYA106/product_image/1694519849926.95d868ed-6acd-4efc-990f-ee892ff3118d.__CR0%2C0%2C970%2C600_PT0_SX970_V1___.jpg",
        desktop_image_url:
          "https://gitsy-b2b-dev.s3.ap-south-1.amazonaws.com/01H6R1GGWD5HE1SSX4TKVYA106/product_image/1694519849926.95d868ed-6acd-4efc-990f-ee892ff3118d.__CR0%2C0%2C970%2C600_PT0_SX970_V1___.jpg",
        dollar_amount: 3.99,
      },
      manufacturer: "spectiv labs",
      brand_name: "Amul",
      provider_text: "radiansys, spectiv labs",
      status: {
        expired: 1,
      },
      access_type: "full_set_with_lock",
      link: "https://gitsyv2app.page.link/BQiZnhqjKueH21GP7",
      is_included_in_gallery: true,
      max_quantity_to_group: "1",
    },
    {
      primary_purchase_gtins: ["037000962564"],
      primary_purchase_eans: [],
      deposited: 24,
      providers: ["radiansys.thecouponbureau.org", "spectivlabs.thecouponbureau.org"],
      rolling_expiration: 1,
      rolling_expiration_days: 7,
      settled: 0,
      finalized: 0,
      lookupcodes: [],
      allowed_retailers: [],
      settlement_email_sent: 0,
      timezone_val: "Pacific/Honolulu",
      create_date: "2023-09-28",
      internal_id: "27a1f907",
      approve_date: "2023-09-28",
      offer_code: "381340",
      base_gs1: "811200497900381340",
      email_domain: "spectivlabs.thecouponbureau.org",
      created_by_email_domain: "spectivlabs.thecouponbureau.org",
      brand_id: "c8c6a17d",
      description:
        "Get 20% off on minimum shopping of 1 unit (Febreze AIR Effects Air Freshener Linen & Sky, 8.8 oz (Pack of 6)) at your nearest store till 3rd October 2023",
      campaign_start_time: "2023-09-26",
      campaign_end_time: "2023-10-10",
      redemption_start_time: "2023-09-26",
      redemption_end_time: "2023-10-10",
      total_circulation: 1000,
      primary_purchase_save_value: 20,
      primary_purchase_requirements: 1,
      primary_purchase_req_code: 0,
      save_value_code: 5,
      store_coupon: 0,
      donot_multiply_flag: 1,
      executionId: "532178f7-33f4-44e1-9d63-d0a6a9760728",
      executedByEmail: "gitsyb2bapikeys_try@spectivlabs.thecouponbureau.org",
      update_datetime: 1696410519895,
      campaign_metadata: {
        allow_override: false,
        title: "Get 20% Off",
        description:
          "Get 20% off on minimum shopping of 1 unit (Febreze AIR Effects Air Freshener Linen & Sky, 8.8 oz (Pack of 6)) at your nearest store till 3rd October 2023",
        terms: "https://thecouponbureau.org/terms",
        mobile_image_url:
          "https://gitsy-b2b-dev.s3.ap-south-1.amazonaws.com/01H6R1GGWD5HE1SSX4TKVYA106/product_image/1695883787302.81ImsR1V1-S._AC_SX679_PIbundle-6%2CTopRight%2C0%2C0_SH20_.jpg",
        desktop_image_url:
          "https://gitsy-b2b-dev.s3.ap-south-1.amazonaws.com/01H6R1GGWD5HE1SSX4TKVYA106/product_image/1695883787302.81ImsR1V1-S._AC_SX679_PIbundle-6%2CTopRight%2C0%2C0_SH20_.jpg",
        dollar_amount: 0,
      },
      manufacturer: "spectiv labs",
      brand_name: "P&G",
      provider_text: "radiansys, spectiv labs",
      status: {
        locked: 1,
      },
      access_type: "full_set_with_lock",
      link: "https://gitsyv2app.page.link/3nVT6nNrq5dXvGBJ7",
      is_included_in_gallery: true,
      max_quantity_to_group: "1",
      max_limit_to_avail_offer: "Single",
    },
    {
      primary_purchase_gtins: [],
      primary_purchase_eans: ["8901262010016"],
      deposited: 2,
      providers: ["spectivlabs.thecouponbureau.org", "radiansys.thecouponbureau.org"],
      rolling_expiration: 1,
      rolling_expiration_days: 7,
      settled: 0,
      finalized: 0,
      lookupcodes: [],
      allowed_retailers: [],
      settlement_email_sent: 0,
      timezone_val: "Pacific/Honolulu",
      create_date: "2023-09-29",
      internal_id: "ab7abff0",
      approve_date: "2023-09-29",
      offer_code: "597921",
      base_gs1: "811200497900597921",
      email_domain: "spectivlabs.thecouponbureau.org",
      created_by_email_domain: "spectivlabs.thecouponbureau.org",
      brand_id: "3de239b9",
      description:
        "Get $2.99 off on minimum shopping of 2 units (Amul Pasteurised Butter) at your nearest store till 7th October 2023",
      campaign_start_time: "2023-09-29",
      campaign_end_time: "2023-10-06",
      redemption_start_time: "2023-10-05",
      redemption_end_time: "2023-10-12",
      total_circulation: 1000,
      primary_purchase_save_value: 299,
      primary_purchase_requirements: 2,
      primary_purchase_req_code: 0,
      save_value_code: 0,
      store_coupon: 0,
      donot_multiply_flag: 1,
      executionId: "73902aee-a3b2-4988-8ade-ba2ee35d0209",
      executedByEmail: "gitsyb2bapikeys_try@spectivlabs.thecouponbureau.org",
      update_datetime: 1695986940022,
      campaign_metadata: {
        allow_override: false,
        title: "Get $2.99 off",
        description:
          "Get $2.99 off on minimum shopping of 2 units (Amul Pasteurised Butter) at your nearest store till 7th October 2023",
        terms: "https://thecouponbureau.org/terms",
        mobile_image_url:
          "https://gitsy-b2b-dev.s3.ap-south-1.amazonaws.com/01H6R1GGWD5HE1SSX4TKVYA106/product_image/1694519849926.95d868ed-6acd-4efc-990f-ee892ff3118d.__CR0%2C0%2C970%2C600_PT0_SX970_V1___.jpg",
        desktop_image_url:
          "https://gitsy-b2b-dev.s3.ap-south-1.amazonaws.com/01H6R1GGWD5HE1SSX4TKVYA106/product_image/1694519849926.95d868ed-6acd-4efc-990f-ee892ff3118d.__CR0%2C0%2C970%2C600_PT0_SX970_V1___.jpg",
        dollar_amount: 2.99,
      },
      manufacturer: "spectiv labs",
      brand_name: "Amul",
      provider_text: "spectiv labs, radiansys",
      status: {
        expired: 1,
      },
      access_type: "full_set_with_lock",
      link: "https://gitsyv2app.page.link/3ASPVke8vazLHiEFA",
      is_included_in_gallery: true,
      max_quantity_to_group: "1",
    },
    {
      primary_purchase_gtins: [],
      primary_purchase_eans: ["8901262010016"],
      deposited: 2,
      providers: ["spectivlabs.thecouponbureau.org", "radiansys.thecouponbureau.org"],
      rolling_expiration: 1,
      rolling_expiration_days: 7,
      settled: 0,
      finalized: 0,
      lookupcodes: [],
      allowed_retailers: [],
      settlement_email_sent: 0,
      timezone_val: "Pacific/Honolulu",
      create_date: "2023-09-29",
      internal_id: "b7e753cb",
      approve_date: "2023-09-29",
      offer_code: "295647",
      base_gs1: "811200497900295647",
      email_domain: "spectivlabs.thecouponbureau.org",
      created_by_email_domain: "spectivlabs.thecouponbureau.org",
      brand_id: "3de239b9",
      description:
        "Save $1.99 on minimum shopping of 1 unit (Amul Pasteurised Butter) at your nearest store till 7th October 2023",
      campaign_start_time: "2023-09-29",
      campaign_end_time: "2023-10-06",
      redemption_start_time: "2023-10-05",
      redemption_end_time: "2023-10-12",
      total_circulation: 1000,
      primary_purchase_save_value: 199,
      primary_purchase_requirements: 1,
      primary_purchase_req_code: 0,
      save_value_code: 0,
      store_coupon: 0,
      donot_multiply_flag: 1,
      executionId: "7cf18fe8-bd78-4af7-a9e5-f6f010baab23",
      executedByEmail: "gitsyb2bapikeys_try@spectivlabs.thecouponbureau.org",
      update_datetime: 1695986893181,
      campaign_metadata: {
        allow_override: false,
        title: "Save $1.99 ",
        description:
          "Save $1.99 on minimum shopping of 1 unit (Amul Pasteurised Butter) at your nearest store till 7th October 2023",
        terms: "https://thecouponbureau.org/terms",
        mobile_image_url:
          "https://gitsy-b2b-dev.s3.ap-south-1.amazonaws.com/01H6R1GGWD5HE1SSX4TKVYA106/product_image/1694519849926.95d868ed-6acd-4efc-990f-ee892ff3118d.__CR0%2C0%2C970%2C600_PT0_SX970_V1___.jpg",
        desktop_image_url:
          "https://gitsy-b2b-dev.s3.ap-south-1.amazonaws.com/01H6R1GGWD5HE1SSX4TKVYA106/product_image/1694519849926.95d868ed-6acd-4efc-990f-ee892ff3118d.__CR0%2C0%2C970%2C600_PT0_SX970_V1___.jpg",
        dollar_amount: 1.99,
      },
      manufacturer: "spectiv labs",
      brand_name: "Amul",
      provider_text: "spectiv labs, radiansys",
      status: {
        expired: 1,
      },
      access_type: "full_set_with_lock",
      link: "https://gitsyv2app.page.link/fKTncidGDsWMe5T69",
      is_included_in_gallery: true,
      max_quantity_to_group: "1",
      max_limit_to_avail_offer: "Single",
    },
    {
      primary_purchase_gtins: ["050700251530"],
      deposited: 42,
      providers: ["spectivlabs.thecouponbureau.org"],
      rolling_expiration: 0,
      settled: 0,
      finalized: 0,
      lookupcodes: [],
      allowed_retailers: [],
      settlement_email_sent: 1,
      timezone_val: "Pacific/Honolulu",
      create_date: "2023-09-26",
      internal_id: "47c852ec",
      approve_date: "2023-09-26",
      offer_code: "441460",
      base_gs1: "811200497900441460",
      email_domain: "spectivlabs.thecouponbureau.org",
      created_by_email_domain: "spectivlabs.thecouponbureau.org",
      brand_id: "844deae0",
      description:
        "Get $1.10 off on minimum shopping of 1 unit (Freshland Dozen Large Eggs) at your nearest store till 3rd October 2023",
      campaign_start_time: "2023-09-25",
      campaign_end_time: "2023-10-03",
      redemption_start_time: "2023-09-27",
      redemption_end_time: "2023-10-03",
      total_circulation: 1000,
      primary_purchase_save_value: 110,
      primary_purchase_requirements: 1,
      primary_purchase_req_code: 0,
      donot_multiply_flag: 1,
      executionId: "46a91958-0ae1-4423-ab48-c8b86d0bb6c5",
      executedByEmail: "148a7d730f1dd0a875aa09f39587c001@spectivlabs.thecouponbureau.org",
      update_datetime: 1695932469546,
      campaign_metadata: {
        allow_override: false,
        title: "Get $1.10 off",
        description:
          "Get $1.10 off on minimum shopping of 1 unit (Freshland Dozen Large Eggs) at your nearest store till 3rd October 2023",
        terms: "https://thecouponbureau.org/terms",
        mobile_image_url:
          "https://gitsy-b2b-dev.s3.ap-south-1.amazonaws.com/01H6R1GGWD5HE1SSX4TKVYA106/product_image/1695703544055.image003%20%281%29.png",
        desktop_image_url:
          "https://gitsy-b2b-dev.s3.ap-south-1.amazonaws.com/01H6R1GGWD5HE1SSX4TKVYA106/product_image/1695703544055.image003%20%281%29.png",
        dollar_amount: 1.1,
      },
      manufacturer: "spectiv labs",
      brand_name: "Freshland",
      provider_text: "spectiv labs",
      status: {
        expired: 1,
      },
      access_type: "full_set_with_lock",
      link: "https://gitsyv2app.page.link/XPZDT9JNe9RA25qa8",
      max_quantity_to_group: "1",
      max_limit_to_avail_offer: "Unlimited",
    },
    {
      primary_purchase_gtins: ["300410106751"],
      primary_purchase_eans: [],
      deposited: 10,
      providers: ["spectivlabs.thecouponbureau.org", "radiansys.thecouponbureau.org"],
      rolling_expiration: 1,
      rolling_expiration_days: 7,
      settled: 0,
      finalized: 0,
      lookupcodes: [],
      allowed_retailers: [],
      settlement_email_sent: 1,
      timezone_val: "Pacific/Honolulu",
      create_date: "2023-09-28",
      internal_id: "768f912c",
      approve_date: "2023-09-28",
      offer_code: "359382",
      base_gs1: "811200497900359382",
      email_domain: "spectivlabs.thecouponbureau.org",
      created_by_email_domain: "spectivlabs.thecouponbureau.org",
      brand_id: "c8c6a17d",
      description:
        "Get 1 unit free on minimum shopping of 3 units (Oral-B Clic Manual Toothbrush with Magnetic Brush Holder) at your nearest store till 3rd October 2023",
      campaign_start_time: "2023-09-26",
      campaign_end_time: "2023-10-03",
      redemption_start_time: "2023-09-26",
      redemption_end_time: "2023-10-03",
      total_circulation: 1000,
      primary_purchase_save_value: 1,
      primary_purchase_requirements: 3,
      primary_purchase_req_code: 0,
      save_value_code: 2,
      store_coupon: 0,
      donot_multiply_flag: 1,
      executionId: "473a50aa-2835-4744-b6c4-adbab9dfbe72",
      executedByEmail: "gitsyb2bapikeys_try@spectivlabs.thecouponbureau.org",
      update_datetime: 1695883580794,
      campaign_metadata: {
        allow_override: false,
        title: "Buy 2 Get 1 Free",
        description:
          "Get 1 unit free on minimum shopping of 3 units (Oral-B Clic Manual Toothbrush with Magnetic Brush Holder) at your nearest store till 3rd October 2023",
        terms: "https://thecouponbureau.org/terms",
        mobile_image_url:
          "https://gitsy-b2b-dev.s3.ap-south-1.amazonaws.com/01H6R1GGWD5HE1SSX4TKVYA106/product_image/1695883424926.71gTqvAwOnL._AC_SX679_.jpg",
        desktop_image_url:
          "https://gitsy-b2b-dev.s3.ap-south-1.amazonaws.com/01H6R1GGWD5HE1SSX4TKVYA106/product_image/1695883424926.71gTqvAwOnL._AC_SX679_.jpg",
        dollar_amount: 0,
      },
      manufacturer: "spectiv labs",
      brand_name: "P&G",
      provider_text: "spectiv labs, radiansys",
      status: {
        expired: 1,
      },
      access_type: "full_set_with_lock",
      link: "https://gitsyv2app.page.link/CpDX7owSFMtV8wcY9",
      is_included_in_gallery: true,
      max_quantity_to_group: "1",
      max_limit_to_avail_offer: "Single",
      free_quantity_type: "unit",
    },
    {
      primary_purchase_gtins: ["080878195978"],
      primary_purchase_eans: [],
      deposited: 7,
      providers: ["radiansys.thecouponbureau.org", "spectivlabs.thecouponbureau.org"],
      rolling_expiration: 1,
      rolling_expiration_days: 7,
      settled: 0,
      finalized: 0,
      lookupcodes: [],
      allowed_retailers: [],
      settlement_email_sent: 1,
      timezone_val: "Pacific/Honolulu",
      create_date: "2023-09-28",
      internal_id: "f29c2f09",
      approve_date: "2023-09-28",
      offer_code: "711808",
      base_gs1: "811200497900711808",
      email_domain: "spectivlabs.thecouponbureau.org",
      created_by_email_domain: "spectivlabs.thecouponbureau.org",
      brand_id: "c8c6a17d",
      description:
        "Save $1.99 on minimum shopping of 1 unit (Pantene Renewal Shampoo 1.13L Conditioner 1.13L Set Value Pack) at your nearest store till 4th October 2023",
      campaign_start_time: "2023-09-27",
      campaign_end_time: "2023-10-04",
      redemption_start_time: "2023-09-27",
      redemption_end_time: "2023-10-04",
      total_circulation: 1000,
      primary_purchase_save_value: 199,
      primary_purchase_requirements: 1,
      primary_purchase_req_code: 0,
      save_value_code: 0,
      store_coupon: 0,
      donot_multiply_flag: 1,
      executionId: "6b57c007-b80d-40e2-9262-0aa52ee9e853",
      executedByEmail: "gitsyb2bapikeys_try@spectivlabs.thecouponbureau.org",
      update_datetime: 1695883085261,
      campaign_metadata: {
        allow_override: false,
        title: "Save $1.99 ",
        description:
          "Save $1.99 on minimum shopping of 1 unit (Pantene Renewal Shampoo 1.13L Conditioner 1.13L Set Value Pack) at your nearest store till 4th October 2023",
        terms: "https://thecouponbureau.org/terms",
        mobile_image_url:
          "https://gitsy-b2b-dev.s3.ap-south-1.amazonaws.com/01H6R1GGWD5HE1SSX4TKVYA106/product_image/1695882768881.61xY1NGu3VL._SY879_.jpg",
        desktop_image_url:
          "https://gitsy-b2b-dev.s3.ap-south-1.amazonaws.com/01H6R1GGWD5HE1SSX4TKVYA106/product_image/1695882768881.61xY1NGu3VL._SY879_.jpg",
        dollar_amount: 1.99,
      },
      manufacturer: "spectiv labs",
      brand_name: "P&G",
      provider_text: "radiansys, spectiv labs",
      status: {
        expired: 1,
      },
      access_type: "full_set_with_lock",
      settled_in_hours: 18,
      link: "https://gitsyv2app.page.link/Bi4EQx8jET42USy4A",
      is_included_in_gallery: true,
      max_quantity_to_group: "1",
    },
    {
      primary_purchase_gtins: ["037000875154"],
      primary_purchase_eans: [],
      deposited: 10,
      providers: ["spectivlabs.thecouponbureau.org", "radiansys.thecouponbureau.org"],
      rolling_expiration: 1,
      rolling_expiration_days: 7,
      settled: 0,
      finalized: 0,
      lookupcodes: [],
      allowed_retailers: [],
      settlement_email_sent: 1,
      timezone_val: "Pacific/Honolulu",
      create_date: "2023-09-28",
      internal_id: "762dbb6f",
      approve_date: "2023-09-28",
      offer_code: "767174",
      base_gs1: "811200497900767174",
      email_domain: "spectivlabs.thecouponbureau.org",
      created_by_email_domain: "spectivlabs.thecouponbureau.org",
      brand_id: "c8c6a17d",
      description:
        "Save $3.50 on minimum shopping of 1 unit (Tide Plus Febreze Freshness Sport High Efficiency Liquid Laundry Detergent - 46 oz - Active Fresh) at your nearest store till 5th October 2023",
      campaign_start_time: "2023-09-27",
      campaign_end_time: "2023-10-04",
      redemption_start_time: "2023-09-26",
      redemption_end_time: "2023-10-04",
      total_circulation: 1000,
      primary_purchase_save_value: 350,
      primary_purchase_requirements: 1,
      primary_purchase_req_code: 0,
      save_value_code: 0,
      store_coupon: 0,
      donot_multiply_flag: 1,
      executionId: "96ab4389-e5df-4d84-b3df-32ccd33ea7f2",
      executedByEmail: "gitsyb2bapikeys_try@spectivlabs.thecouponbureau.org",
      update_datetime: 1695882828815,
      campaign_metadata: {
        allow_override: false,
        title: "Save $3.50 ",
        description:
          "Save $3.50 on minimum shopping of 1 unit (Tide Plus Febreze Freshness Sport High Efficiency Liquid Laundry Detergent - 46 oz - Active Fresh) at your nearest store till 5th October 2023",
        terms: "https://thecouponbureau.org/terms",
        mobile_image_url:
          "https://gitsy-b2b-dev.s3.ap-south-1.amazonaws.com/01H6R1GGWD5HE1SSX4TKVYA106/product_image/1695876594547.81FCTZrqfcL._AC_SX679_.jpg",
        desktop_image_url:
          "https://gitsy-b2b-dev.s3.ap-south-1.amazonaws.com/01H6R1GGWD5HE1SSX4TKVYA106/product_image/1695876594547.81FCTZrqfcL._AC_SX679_.jpg",
        dollar_amount: 3.5,
      },
      manufacturer: "spectiv labs",
      brand_name: "P&G",
      provider_text: "spectiv labs, radiansys",
      status: {
        expired: 1,
      },
      access_type: "full_set_with_lock",
      settled_in_hours: 18,
      link: "https://gitsyv2app.page.link/xaCvYXAeiq1SfNYz9",
      max_quantity_to_group: "1",
      max_limit_to_avail_offer: "Single",
    },
    {
      primary_purchase_eans: ["8901262010016"],
      deposited: 7,
      providers: ["spectivlabs.thecouponbureau.org", "radiansys.thecouponbureau.org"],
      rolling_expiration: 0,
      settled: 0,
      finalized: 0,
      lookupcodes: [],
      allowed_retailers: [],
      settlement_email_sent: 1,
      timezone_val: "Pacific/Honolulu",
      create_date: "2023-09-26",
      internal_id: "0aaacbca",
      approve_date: "2023-09-26",
      offer_code: "742648",
      base_gs1: "811200497900742648",
      email_domain: "spectivlabs.thecouponbureau.org",
      created_by_email_domain: "spectivlabs.thecouponbureau.org",
      brand_id: "3de239b9",
      description:
        "Save $20.00 on minimum shopping of 20 units (Amul Pasteurised Butter) at your nearest store till 4th October 2023",
      campaign_start_time: "2023-09-25",
      campaign_end_time: "2023-10-03",
      redemption_start_time: "2023-09-27",
      redemption_end_time: "2023-10-04",
      total_circulation: 1000,
      primary_purchase_save_value: 2000,
      primary_purchase_requirements: 20,
      primary_purchase_req_code: 0,
      donot_multiply_flag: 1,
      executionId: "09913acb-0d65-4952-a382-7e1a8b2dcb63",
      executedByEmail: "148a7d730f1dd0a875aa09f39587c001@spectivlabs.thecouponbureau.org",
      update_datetime: 1695711167625,
      campaign_metadata: {
        allow_override: false,
        title: "Save $20.00 ",
        description:
          "Save $20.00 on minimum shopping of 20 units (Amul Pasteurised Butter) at your nearest store till 4th October 2023",
        terms: "https://thecouponbureau.org/terms",
        mobile_image_url:
          "https://gitsy-b2b-dev.s3.ap-south-1.amazonaws.com/01H6R1GGWD5HE1SSX4TKVYA106/product_image/1694519849926.95d868ed-6acd-4efc-990f-ee892ff3118d.__CR0%2C0%2C970%2C600_PT0_SX970_V1___.jpg",
        desktop_image_url:
          "https://gitsy-b2b-dev.s3.ap-south-1.amazonaws.com/01H6R1GGWD5HE1SSX4TKVYA106/product_image/1694519849926.95d868ed-6acd-4efc-990f-ee892ff3118d.__CR0%2C0%2C970%2C600_PT0_SX970_V1___.jpg",
        dollar_amount: 20,
      },
      manufacturer: "spectiv labs",
      brand_name: "Amul",
      provider_text: "spectiv labs, radiansys",
      status: {
        expired: 1,
      },
      access_type: "full_set_with_lock",
      settled_in_hours: 18,
      link: "https://gitsyv2app.page.link/gP2STT5Q9BKrfZ9z7",
      max_quantity_to_group: "1",
      max_limit_to_avail_offer: "Single",
    },
    {
      primary_purchase_gtins: [],
      primary_purchase_eans: ["8901262010016"],
      deposited: 23,
      providers: ["spectivlabs.thecouponbureau.org", "radiansys.thecouponbureau.org"],
      rolling_expiration: 1,
      rolling_expiration_days: 7,
      settled: 1,
      finalized: 0,
      lookupcodes: [],
      allowed_retailers: [],
      settlement_email_sent: 1,
      timezone_val: "Pacific/Honolulu",
      create_date: "2023-09-22",
      internal_id: "5bd54f9b",
      approve_date: "2023-09-22",
      offer_code: "610366",
      base_gs1: "811200497900610366",
      email_domain: "spectivlabs.thecouponbureau.org",
      created_by_email_domain: "spectivlabs.thecouponbureau.org",
      brand_id: "3de239b9",
      description:
        "Save $10.00 on minimum shopping of 10 units (Amul Pasteurised Butter) at your nearest store till 29th September 2023",
      campaign_start_time: "2023-09-21",
      campaign_end_time: "2023-09-29",
      redemption_start_time: "2023-09-21",
      redemption_end_time: "2023-09-29",
      total_circulation: 1000,
      primary_purchase_save_value: 1000,
      primary_purchase_requirements: 10,
      primary_purchase_req_code: 0,
      save_value_code: 0,
      store_coupon: 0,
      donot_multiply_flag: 1,
      executionId: "6bba284e-1335-430c-840c-d7ead506cc11",
      executedByEmail: "gitsyb2bapikeys_try@spectivlabs.thecouponbureau.org",
      update_datetime: 1695708781339,
      campaign_metadata: {
        allow_override: false,
        title: "Save $10.00 ",
        description:
          "Save $10.00 on minimum shopping of 10 units (Amul Pasteurised Butter) at your nearest store till 29th September 2023",
        terms: "https://thecouponbureau.org/terms",
        mobile_image_url:
          "https://gitsy-b2b-dev.s3.ap-south-1.amazonaws.com/01H6R1GGWD5HE1SSX4TKVYA106/product_image/1694519849926.95d868ed-6acd-4efc-990f-ee892ff3118d.__CR0%2C0%2C970%2C600_PT0_SX970_V1___.jpg",
        desktop_image_url:
          "https://gitsy-b2b-dev.s3.ap-south-1.amazonaws.com/01H6R1GGWD5HE1SSX4TKVYA106/product_image/1694519849926.95d868ed-6acd-4efc-990f-ee892ff3118d.__CR0%2C0%2C970%2C600_PT0_SX970_V1___.jpg",
        dollar_amount: 10,
      },
      settled_datetime: "2023-10-08",
      manufacturer: "spectiv labs",
      brand_name: "Amul",
      provider_text: "spectiv labs, radiansys",
      status: {
        expired: 1,
      },
      access_type: "full_set_with_lock",
      link: "https://gitsyv2app.page.link/UUf1c4qsc2RY3rNj7",
      max_quantity_to_group: "1",
      max_limit_to_avail_offer: "Single",
    },
    {
      primary_purchase_gtins: ["074609072409"],
      primary_purchase_eans: [],
      deposited: 0,
      providers: [],
      rolling_expiration: 0,
      settled: 1,
      finalized: 0,
      lookupcodes: [],
      allowed_retailers: [],
      settlement_email_sent: 1,
      timezone_val: "Pacific/Honolulu",
      create_date: "2023-09-21",
      internal_id: "4b3ea4ab",
      approve_date: "2023-09-21",
      offer_code: "253970",
      base_gs1: "811200497900253970",
      email_domain: "spectivlabs.thecouponbureau.org",
      created_by_email_domain: "spectivlabs.thecouponbureau.org",
      brand_id: "2ca63891",
      description:
        "Save $0.50 on minimum shopping of 1 unit (KC Masterpiece Original Barbecue Sauce 18 Oz) at your nearest store till 19th September 2023",
      campaign_start_time: "2023-09-13",
      campaign_end_time: "2023-09-19",
      redemption_start_time: "2023-09-13",
      redemption_end_time: "2023-09-19",
      total_circulation: 1000,
      primary_purchase_save_value: 50,
      primary_purchase_requirements: 1,
      primary_purchase_req_code: 0,
      save_value_code: 0,
      store_coupon: 0,
      donot_multiply_flag: 1,
      executionId: "4a8c306a-9117-4d56-ab48-f6f564a6a5ab",
      executedByEmail: "148a7d730f1dd0a875aa09f39587c001@spectivlabs.thecouponbureau.org",
      update_datetime: 1695631929765,
      campaign_metadata: {
        allow_override: false,
        title: "Save $0.50 ",
        description:
          "Save $0.50 on minimum shopping of 1 unit (KC Masterpiece Original Barbecue Sauce 18 Oz) at your nearest store till 19th September 2023",
        terms: "https://thecouponbureau.org/terms",
        mobile_image_url:
          "https://gitsy-b2b-dev.s3.ap-south-1.amazonaws.com/01H6R1GGWD5HE1SSX4TKVYA106/product_image/1694494665078.unnamed.png",
        desktop_image_url:
          "https://gitsy-b2b-dev.s3.ap-south-1.amazonaws.com/01H6R1GGWD5HE1SSX4TKVYA106/product_image/1694494665078.unnamed.png",
        dollar_amount: 0.5,
      },
      settled_datetime: "2023-09-28",
      manufacturer: "spectiv labs",
      brand_name: "KC Masterpiece",
      provider_text: "",
      status: {
        expired: 1,
      },
      access_type: "full_set_with_lock",
      link: "https://gitsyv2app.page.link/15KMCXnZHgQRVASo6",
      max_quantity_to_group: "1",
    },
    {
      primary_purchase_gtins: ["074609072409"],
      primary_purchase_eans: [],
      deposited: 26,
      providers: ["spectivlabs.thecouponbureau.org", "radiansys.thecouponbureau.org"],
      rolling_expiration: 0,
      settled: 0,
      finalized: 0,
      lookupcodes: [],
      allowed_retailers: [],
      settlement_email_sent: 1,
      timezone_val: "Pacific/Honolulu",
      create_date: "2023-09-22",
      internal_id: "dae5b268",
      approve_date: "2023-09-22",
      offer_code: "261850",
      base_gs1: "811200497900261850",
      email_domain: "spectivlabs.thecouponbureau.org",
      created_by_email_domain: "spectivlabs.thecouponbureau.org",
      brand_id: "2ca63891",
      description:
        "Save $2.50 on minimum shopping of 1 unit (KC Masterpiece Original Barbecue Sauce 18 Oz) at your nearest store till 31st October 2023",
      campaign_start_time: "2023-09-21",
      campaign_end_time: "2023-10-31",
      redemption_start_time: "2023-09-21",
      redemption_end_time: "2023-10-31",
      total_circulation: 1000,
      primary_purchase_save_value: 250,
      primary_purchase_requirements: 1,
      primary_purchase_req_code: 0,
      save_value_code: 0,
      store_coupon: 0,
      donot_multiply_flag: 1,
      executionId: "a7a77a9f-08ca-4ce1-99bd-7530a26961d2",
      executedByEmail: "gitsyb2bapikeys_try@spectivlabs.thecouponbureau.org",
      update_datetime: 1695377576808,
      campaign_metadata: {
        allow_override: false,
        title: "Save $2.50 ",
        description:
          "Save $2.50 on minimum shopping of 1 unit (KC Masterpiece Original Barbecue Sauce 18 Oz) at your nearest store till 31st October 2023",
        terms: "https://thecouponbureau.org/terms",
        mobile_image_url:
          "https://gitsy-b2b-dev.s3.ap-south-1.amazonaws.com/01H6R1GGWD5HE1SSX4TKVYA106/product_image/1694494665078.unnamed.png",
        desktop_image_url:
          "https://gitsy-b2b-dev.s3.ap-south-1.amazonaws.com/01H6R1GGWD5HE1SSX4TKVYA106/product_image/1694494665078.unnamed.png",
        dollar_amount: 2.5,
      },
      manufacturer: "spectiv labs",
      brand_name: "KC Masterpiece",
      provider_text: "spectiv labs, radiansys",
      status: {
        locked: 1,
      },
      access_type: "full_set_with_lock",
      link: "https://gitsyv2app.page.link/ojnGjVapzBXPGx4W7",
      is_included_in_gallery: true,
      max_quantity_to_group: "1",
      max_limit_to_avail_offer: "Single",
    },
    {
      primary_purchase_gtins: ["074609072409"],
      primary_purchase_eans: [],
      deposited: 42,
      providers: ["radiansys.thecouponbureau.org", "spectivlabs.thecouponbureau.org"],
      rolling_expiration: 0,
      settled: 1,
      finalized: 0,
      lookupcodes: [],
      allowed_retailers: [],
      settlement_email_sent: 1,
      timezone_val: "Pacific/Honolulu",
      create_date: "2023-09-21",
      internal_id: "40a6fe44",
      approve_date: "2023-09-21",
      offer_code: "059528",
      base_gs1: "811200497900059528",
      email_domain: "spectivlabs.thecouponbureau.org",
      created_by_email_domain: "spectivlabs.thecouponbureau.org",
      brand_id: "2ca63891",
      description:
        "Get $2.60 off on minimum shopping of 1 unit (KC Masterpiece Original Barbecue Sauce 18 Oz) at your nearest store till 26th September 2023",
      campaign_start_time: "2023-09-18",
      campaign_end_time: "2023-09-26",
      redemption_start_time: "2023-09-20",
      redemption_end_time: "2023-09-26",
      total_circulation: 1000,
      primary_purchase_save_value: 260,
      primary_purchase_requirements: 1,
      primary_purchase_req_code: 0,
      save_value_code: 0,
      store_coupon: 0,
      donot_multiply_flag: 1,
      executionId: "041a9268-7975-40f0-99a8-64da2033fdfc",
      executedByEmail: "gitsyb2bapikeys_try@spectivlabs.thecouponbureau.org",
      update_datetime: 1695288343749,
      campaign_metadata: {
        allow_override: false,
        title: "Get $2.60 off",
        description:
          "Get $2.60 off on minimum shopping of 1 unit (KC Masterpiece Original Barbecue Sauce 18 Oz) at your nearest store till 26th September 2023",
        terms: "https://thecouponbureau.org/terms",
        mobile_image_url:
          "https://gitsy-b2b-dev.s3.ap-south-1.amazonaws.com/01H6R1GGWD5HE1SSX4TKVYA106/product_image/1695050427596.image001.png",
        desktop_image_url:
          "https://gitsy-b2b-dev.s3.ap-south-1.amazonaws.com/01H6R1GGWD5HE1SSX4TKVYA106/product_image/1695050427596.image001.png",
        dollar_amount: 2.6,
      },
      settled_datetime: "2023-10-05",
      manufacturer: "spectiv labs",
      brand_name: "KC Masterpiece",
      provider_text: "radiansys, spectiv labs",
      status: {
        expired: 1,
      },
      access_type: "full_set_with_lock",
      link: "https://gitsyv2app.page.link/VhTdL2d1iShv6iVU7",
      max_quantity_to_group: "1",
    },
    {
      primary_purchase_gtins: ["193476004402"],
      deposited: 13,
      providers: ["spectivlabs.thecouponbureau.org"],
      rolling_expiration: 0,
      settled: 1,
      finalized: 0,
      lookupcodes: [],
      allowed_retailers: [],
      settlement_email_sent: 1,
      timezone_val: "Pacific/Honolulu",
      create_date: "2023-09-18",
      internal_id: "938164d2",
      approve_date: "2023-09-18",
      offer_code: "728413",
      base_gs1: "811200497900728413",
      email_domain: "spectivlabs.thecouponbureau.org",
      created_by_email_domain: "spectivlabs.thecouponbureau.org",
      brand_id: "b19c5e4b",
      description:
        "Save $2.60 on minimum shopping of 1 unit (PURE CANE GRANULATED SUGAR 4 Lb) at your nearest store till 26th September 2023",
      campaign_start_time: "2023-09-18",
      campaign_end_time: "2023-09-26",
      redemption_start_time: "2023-09-20",
      redemption_end_time: "2023-09-26",
      total_circulation: 1000,
      primary_purchase_save_value: 260,
      primary_purchase_requirements: 1,
      primary_purchase_req_code: 0,
      donot_multiply_flag: 1,
      executionId: "bcf1fafc-f0a3-4147-aab4-dff0d1c28018",
      executedByEmail: "148a7d730f1dd0a875aa09f39587c001@spectivlabs.thecouponbureau.org",
      update_datetime: 1695054196715,
      campaign_metadata: {
        allow_override: false,
        title: "Save $2.60 ",
        description:
          "Save $2.60 on minimum shopping of 1 unit (PURE CANE GRANULATED SUGAR 4 Lb) at your nearest store till 26th September 2023",
        terms: "https://thecouponbureau.org/terms",
        mobile_image_url:
          "https://gitsy-b2b-dev.s3.ap-south-1.amazonaws.com/01H6R1GGWD5HE1SSX4TKVYA106/product_image/1695050427596.image001.png",
        desktop_image_url:
          "https://gitsy-b2b-dev.s3.ap-south-1.amazonaws.com/01H6R1GGWD5HE1SSX4TKVYA106/product_image/1695050427596.image001.png",
        dollar_amount: 2.6,
      },
      settled_datetime: "2023-10-05",
      manufacturer: "spectiv labs",
      brand_name: "That's Smart",
      provider_text: "spectiv labs",
      status: {
        expired: 1,
      },
      access_type: "full_set_with_lock",
      link: "https://gitsyv2app.page.link/xYFpo4QcGod3VXrq9",
      max_quantity_to_group: "1",
      max_limit_to_avail_offer: "Unlimited",
    },
    {
      primary_purchase_gtins: [],
      primary_purchase_eans: [],
      deposited: 2,
      providers: ["spectivlabs.thecouponbureau.org", "radiansys.thecouponbureau.org"],
      rolling_expiration: 1,
      rolling_expiration_days: 7,
      settled: 0,
      finalized: 0,
      lookupcodes: [],
      allowed_retailers: [],
      settlement_email_sent: 0,
      timezone_val: "Pacific/Honolulu",
      create_date: "2023-09-12",
      internal_id: "07bd4a76",
      approve_date: "2023-09-12",
      offer_code: "697588",
      base_gs1: "811200497900697588",
      email_domain: "spectivlabs.thecouponbureau.org",
      created_by_email_domain: "spectivlabs.thecouponbureau.org",
      brand_id: "b2872b67",
      description:
        "Save $10.00 on minimum shopping of 3 units (new_product_5 OR test invalid product OR new_product_8 OR Fresh Lime Soda OR new_product_10) at your nearest store till 12th October 2023",
      campaign_start_time: "2023-09-12",
      campaign_end_time: "2023-09-19",
      redemption_start_time: "2023-09-13",
      redemption_end_time: "2023-10-13",
      total_circulation: 1000,
      primary_purchase_save_value: 1000,
      primary_purchase_requirements: 3,
      primary_purchase_req_code: 0,
      save_value_code: 0,
      store_coupon: 1,
      donot_multiply_flag: 1,
      executionId: "4807cfb1-ad87-4535-9478-cea6b3a98b27",
      executedByEmail: "gitsyb2bapikeys_try@spectivlabs.thecouponbureau.org",
      update_datetime: 1694512916790,
      campaign_metadata: {
        allow_override: false,
        title: "Save $10.00 ",
        description:
          "Save $10.00 on minimum shopping of 3 units (new_product_5 OR test invalid product OR new_product_8 OR Fresh Lime Soda OR new_product_10) at your nearest store till 12th October 2023",
        terms: "https://thecouponbureau.org/terms",
        mobile_image_url:
          "https://gitsy-b2b-dev.s3.ap-south-1.amazonaws.com/01H6R1GGWD5HE1SSX4TKVYA106/product_image/1694167293853.61WMf8k8JWL._SX679_.jpg",
        desktop_image_url:
          "https://gitsy-b2b-dev.s3.ap-south-1.amazonaws.com/01H6R1GGWD5HE1SSX4TKVYA106/product_image/1694167293853.61WMf8k8JWL._SX679_.jpg",
        dollar_amount: 10,
      },
      manufacturer: "spectiv labs",
      brand_name: "test_brand_2",
      provider_text: "spectiv labs, radiansys",
      status: {
        expired: 1,
      },
      access_type: "full_set_with_lock",
      link: "https://gitsyv2app.page.link/YyHcUVDVod3LJz4w8",
      max_quantity_to_group: "1",
      max_limit_to_avail_offer: "Single",
    },
    {
      primary_purchase_gtins: ["074609072409"],
      deposited: 7,
      providers: ["spectivlabs.thecouponbureau.org"],
      rolling_expiration: 0,
      settled: 1,
      finalized: 0,
      lookupcodes: [],
      allowed_retailers: [],
      settlement_email_sent: 1,
      timezone_val: "Pacific/Honolulu",
      create_date: "2023-09-12",
      internal_id: "7305de72",
      approve_date: "2023-09-12",
      offer_code: "370903",
      base_gs1: "811200497900370903",
      email_domain: "spectivlabs.thecouponbureau.org",
      created_by_email_domain: "spectivlabs.thecouponbureau.org",
      brand_id: "2ca63891",
      description:
        "Save $0.50 on minimum shopping of 1 unit (KC Masterpiece Original Barbecue Sauce 18 Oz) at your nearest store till 19th September 2023",
      campaign_start_time: "2023-09-13",
      campaign_end_time: "2023-09-19",
      redemption_start_time: "2023-09-13",
      redemption_end_time: "2023-09-19",
      total_circulation: 1000,
      primary_purchase_save_value: 50,
      primary_purchase_requirements: 1,
      primary_purchase_req_code: 0,
      donot_multiply_flag: 1,
      executionId: "f11e07df-91fc-41fe-847e-55cc7744be22",
      executedByEmail: "148a7d730f1dd0a875aa09f39587c001@spectivlabs.thecouponbureau.org",
      update_datetime: 1694502677503,
      campaign_metadata: {
        allow_override: false,
        title: "Save $0.50 ",
        description:
          "Save $0.50 on minimum shopping of 1 unit (KC Masterpiece Original Barbecue Sauce 18 Oz) at your nearest store till 19th September 2023",
        terms: "https://thecouponbureau.org/terms",
        mobile_image_url:
          "https://gitsy-b2b-dev.s3.ap-south-1.amazonaws.com/01H6R1GGWD5HE1SSX4TKVYA106/product_image/1694494665078.unnamed.png",
        desktop_image_url:
          "https://gitsy-b2b-dev.s3.ap-south-1.amazonaws.com/01H6R1GGWD5HE1SSX4TKVYA106/product_image/1694494665078.unnamed.png",
        dollar_amount: 0.5,
      },
      settled_datetime: "2023-09-28",
      manufacturer: "spectiv labs",
      brand_name: "KC Masterpiece",
      provider_text: "spectiv labs",
      status: {
        expired: 1,
      },
      access_type: "full_set_with_lock",
      link: "https://gitsyv2app.page.link/BByK6ixfB2ZtRnZt6",
      max_quantity_to_group: "1",
      max_limit_to_avail_offer: "Unlimited",
    },
    {
      primary_purchase_gtins: ["123456789012"],
      primary_purchase_eans: [],
      deposited: 4,
      providers: ["spectivlabs.thecouponbureau.org", "radiansys.thecouponbureau.org"],
      rolling_expiration: 1,
      rolling_expiration_days: 7,
      settled: 1,
      finalized: 0,
      lookupcodes: [],
      allowed_retailers: [],
      settlement_email_sent: 1,
      timezone_val: "Pacific/Honolulu",
      create_date: "2023-09-12",
      internal_id: "7bc7fae4",
      approve_date: "2023-09-12",
      offer_code: "699881",
      base_gs1: "811200497900699881",
      email_domain: "spectivlabs.thecouponbureau.org",
      created_by_email_domain: "spectivlabs.thecouponbureau.org",
      brand_id: "b2872b67",
      description:
        "Get $23.00 off on minimum shopping of 13 units (new_product_5) at your nearest store till 19th September 2023",
      campaign_start_time: "2023-09-12",
      campaign_end_time: "2023-09-19",
      redemption_start_time: "2023-09-12",
      redemption_end_time: "2023-09-19",
      total_circulation: 1000,
      primary_purchase_save_value: 2300,
      primary_purchase_requirements: 13,
      primary_purchase_req_code: 0,
      save_value_code: 0,
      store_coupon: 1,
      donot_multiply_flag: 1,
      executionId: "7d6ea05e-0017-4a3a-8aa0-961b16dac576",
      executedByEmail: "gitsyb2bapikeys_try@spectivlabs.thecouponbureau.org",
      update_datetime: 1694501600189,
      campaign_metadata: {
        allow_override: false,
        title: "Get $23.00 off",
        description:
          "Get $23.00 off on minimum shopping of 13 units (new_product_5) at your nearest store till 19th September 2023",
        terms: "https://thecouponbureau.org/terms",
        mobile_image_url:
          "https://gitsy-b2b-dev.s3.ap-south-1.amazonaws.com/01H6R1GGWD5HE1SSX4TKVYA106/product_image/1694175898037.depositphotos_256778368-stock-illustration-vector-cartoon-slush-icon-isolated.jpg",
        desktop_image_url:
          "https://gitsy-b2b-dev.s3.ap-south-1.amazonaws.com/01H6R1GGWD5HE1SSX4TKVYA106/product_image/1694175898037.depositphotos_256778368-stock-illustration-vector-cartoon-slush-icon-isolated.jpg",
        dollar_amount: 23,
      },
      settled_datetime: "2023-09-28",
      manufacturer: "spectiv labs",
      brand_name: "test_brand_2",
      provider_text: "spectiv labs, radiansys",
      status: {
        expired: 1,
      },
      access_type: "full_set_with_lock",
      link: "https://gitsyv2app.page.link/MBVNhcp6Qn9WdacYA",
      max_quantity_to_group: "1",
      max_limit_to_avail_offer: "Single",
    },
    {
      primary_purchase_gtins: [],
      primary_purchase_eans: [],
      deposited: 2,
      providers: ["spectivlabs.thecouponbureau.org", "radiansys.thecouponbureau.org"],
      rolling_expiration: 1,
      rolling_expiration_days: 7,
      settled: 1,
      finalized: 0,
      lookupcodes: [],
      allowed_retailers: [],
      settlement_email_sent: 1,
      primary_purchase_prefixed_code: ["PLU:radiansys.thecouponbureau.org:435796472"],
      timezone_val: "Pacific/Honolulu",
      create_date: "2023-09-12",
      internal_id: "ae4143dc",
      approve_date: "2023-09-12",
      offer_code: "453384",
      base_gs1: "811200497900453384",
      email_domain: "spectivlabs.thecouponbureau.org",
      created_by_email_domain: "spectivlabs.thecouponbureau.org",
      brand_id: "3de239b9",
      description:
        "Get $10.00 off on minimum shopping of 50 units (ice cream 3) at your nearest store till 19th September 2023",
      campaign_start_time: "2023-09-12",
      campaign_end_time: "2023-09-19",
      redemption_start_time: "2023-09-12",
      redemption_end_time: "2023-09-19",
      total_circulation: 1000,
      primary_purchase_save_value: 1000,
      primary_purchase_requirements: 50,
      primary_purchase_req_code: 0,
      save_value_code: 0,
      store_coupon: 1,
      donot_multiply_flag: 1,
      executionId: "1d36eca7-c81f-4509-82f1-ddb2a17f4597",
      executedByEmail: "gitsyb2bapikeys_try@spectivlabs.thecouponbureau.org",
      update_datetime: 1694501072726,
      campaign_metadata: {
        allow_override: false,
        title: "Get $10.00 off",
        description:
          "Get $10.00 off on minimum shopping of 50 units (ice cream 3) at your nearest store till 19th September 2023",
        terms: "https://thecouponbureau.org/terms",
        mobile_image_url:
          "https://gitsy-b2b-dev.s3.ap-south-1.amazonaws.com/01H6R1GGWD5HE1SSX4TKVYA106/product_image/1694500834867.depositphotos_256778368-stock-illustration-vector-cartoon-slush-icon-isolated.jpg",
        desktop_image_url:
          "https://gitsy-b2b-dev.s3.ap-south-1.amazonaws.com/01H6R1GGWD5HE1SSX4TKVYA106/product_image/1694500834867.depositphotos_256778368-stock-illustration-vector-cartoon-slush-icon-isolated.jpg",
        dollar_amount: 10,
      },
      settled_datetime: "2023-09-28",
      manufacturer: "spectiv labs",
      brand_name: "Amul",
      provider_text: "spectiv labs, radiansys",
      status: {
        expired: 1,
      },
      access_type: "full_set_with_lock",
      link: "https://gitsyv2app.page.link/EoRaiWXYk4rWajve6",
      max_quantity_to_group: "1",
      max_limit_to_avail_offer: "Single",
    },
    {
      primary_purchase_gtins: ["049000031652"],
      primary_purchase_eans: [],
      deposited: 17,
      providers: ["spectivlabs.thecouponbureau.org"],
      settled: 1,
      finalized: 0,
      lookupcodes: [],
      allowed_retailers: [],
      settlement_email_sent: 1,
      timezone_val: "Pacific/Honolulu",
      create_date: "2023-08-31",
      internal_id: "8424511d",
      approve_date: "2023-08-31",
      offer_code: "456543",
      base_gs1: "811200497900456543",
      email_domain: "spectivlabs.thecouponbureau.org",
      created_by_email_domain: "spectivlabs.thecouponbureau.org",
      brand_id: "3e02eac6",
      description:
        "24-pack Dasani Purified Water $2.99 after coupon of $3.50.  Save $3.50 on minimum shopping of 1 unit (DASANI Purified Water Bottles, 16.9 Fl Oz, 24 Pack) at your nearest store till 12th September 2023",
      campaign_start_time: "2023-09-05",
      campaign_end_time: "2023-09-12",
      redemption_start_time: "2023-09-05",
      redemption_end_time: "2023-09-12",
      total_circulation: 1000,
      primary_purchase_save_value: 350,
      primary_purchase_requirements: 1,
      primary_purchase_req_code: 0,
      save_value_code: 0,
      store_coupon: 0,
      donot_multiply_flag: 1,
      executionId: "b432b2b1-5f92-4ef6-a29f-29ca85bf50d4",
      executedByEmail: "gitsyb2bapikeys_try@spectivlabs.thecouponbureau.org",
      update_datetime: 1694496133191,
      campaign_metadata: {
        allow_override: false,
        title: "Save $3.50",
        description:
          "24-pack Dasani Purified Water $2.99 after coupon of $3.50.  Save $3.50 on minimum shopping of 1 unit (DASANI Purified Water Bottles, 16.9 Fl Oz, 24 Pack) at your nearest store till 12th September 2023",
        terms: "https://thecouponbureau.org/terms",
        mobile_image_url:
          "https://gitsy-b2b-dev.s3.ap-south-1.amazonaws.com/01H6R1GGWD5HE1SSX4TKVYA106/product_image/1693460492721.image002.png",
        desktop_image_url:
          "https://gitsy-b2b-dev.s3.ap-south-1.amazonaws.com/01H6R1GGWD5HE1SSX4TKVYA106/product_image/1693460492721.image002.png",
        dollar_amount: 3.5,
      },
      rolling_expiration: 0,
      settled_datetime: "2023-09-21",
      manufacturer: "spectiv labs",
      brand_name: "DASANI",
      provider_text: "spectiv labs",
      status: {
        expired: 1,
      },
      access_type: "full_set_with_lock",
      link: "https://gitsyv2app.page.link/7gTZwV1fsyVmbUgz5",
    },
    {
      deposited: 2,
      providers: ["radiansys.thecouponbureau.org", "spectivlabs.thecouponbureau.org"],
      rolling_expiration: 1,
      rolling_expiration_days: 7,
      settled: 1,
      finalized: 0,
      lookupcodes: [],
      allowed_retailers: [],
      settlement_email_sent: 1,
      primary_purchase_prefixed_code: ["PLU:radiansys.thecouponbureau.org:697"],
      timezone_val: "Pacific/Honolulu",
      create_date: "2023-09-08",
      internal_id: "0941d3f8",
      approve_date: "2023-09-08",
      offer_code: "969049",
      base_gs1: "811200497900969049",
      email_domain: "spectivlabs.thecouponbureau.org",
      created_by_email_domain: "spectivlabs.thecouponbureau.org",
      brand_id: "17c666ba",
      description:
        "Get $4.99 off on minimum shopping of 10 units (test_product_edit_mode_1) at your nearest store till 7th October 2023",
      campaign_start_time: "2023-09-07",
      campaign_end_time: "2023-09-14",
      redemption_start_time: "2023-09-08",
      redemption_end_time: "2023-09-15",
      total_circulation: 1000,
      primary_purchase_save_value: 499,
      primary_purchase_requirements: 10,
      primary_purchase_req_code: 0,
      donot_multiply_flag: 1,
      executionId: "642b505f-ee65-495e-a8e6-98f86b2720a0",
      executedByEmail: "gitsyb2bapikeys_try@spectivlabs.thecouponbureau.org",
      update_datetime: 1694173372190,
      campaign_metadata: {
        allow_override: false,
        title: "Get $4.99 off",
        description:
          "Get $4.99 off on minimum shopping of 10 units (test_product_edit_mode_1) at your nearest store till 7th October 2023",
        terms: "https://thecouponbureau.org/terms",
        mobile_image_url:
          "https://gitsy-b2b-dev.s3.ap-south-1.amazonaws.com/01H6R1GGWD5HE1SSX4TKVYA106/product_image/1692606270139.1690193143490.Mask.png",
        desktop_image_url:
          "https://gitsy-b2b-dev.s3.ap-south-1.amazonaws.com/01H6R1GGWD5HE1SSX4TKVYA106/product_image/1692606270139.1690193143490.Mask.png",
        dollar_amount: 4.99,
      },
      settled_datetime: "2023-09-24",
      manufacturer: "spectiv labs",
      brand_name: "test_brand_1",
      provider_text: "radiansys, spectiv labs",
      status: {
        expired: 1,
      },
      access_type: "full_set_with_lock",
      link: "https://gitsyv2app.page.link/WEcgKupEVWtkStJi7",
      max_quantity_to_group: "1",
      max_limit_to_avail_offer: "Single",
    },
    {
      primary_purchase_gtins: [
        "070253001949",
        "070253001963",
        "070253001536",
        "070253001970",
        "070253001932",
        "070253001987",
      ],
      deposited: 79,
      providers: ["spectivlabs.thecouponbureau.org"],
      rolling_expiration: 1,
      rolling_expiration_days: 15,
      settled: 1,
      finalized: 0,
      lookupcodes: [],
      allowed_retailers: [],
      settlement_email_sent: 1,
      primary_purchase_prefixed_code: ["PLU:all:88-99", "PLU:all:87"],
      third_purchase_prefixed_code: ["PLU:all:388-399", "PLU:all:387"],
      timezone_val: "Pacific/Honolulu",
      create_date: "2023-04-20",
      internal_id: "77170c76",
      approve_date: "2023-04-20",
      offer_code: "765123",
      base_gs1: "811200497900765123",
      email_domain: "spectivlabs.thecouponbureau.org",
      created_by_email_domain: "spectivlabs.thecouponbureau.org",
      brand_id: "12648298",
      description: "Our Family Brand potato chips - Save $1",
      campaign_start_time: "2023-04-20",
      campaign_end_time: "2023-05-18",
      redemption_start_time: "2023-04-20",
      redemption_end_time: "2023-05-18",
      total_circulation: 100,
      primary_purchase_save_value: 100,
      primary_purchase_requirements: 1,
      primary_purchase_req_code: 0,
      executionId: "1a33a09e-df5f-45ad-8231-f9b782110379",
      executedByEmail: "148a7d730f1dd0a875aa09f39587c001@spectivlabs.thecouponbureau.org",
      update_datetime: 1694167010620,
      campaign_metadata: {
        allow_override: false,
        title: "Save $1",
        description: "Our Family Brand potato chips - Save $1",
        terms: "https://thecouponbureau.org/terms",
        mobile_image_url: "https://gitsy-product-images.s3.amazonaws.com/our_family_chips.png",
        desktop_image_url: "https://gitsy-product-images.s3.amazonaws.com/our_family_chips.png",
        dollar_amount: 1,
      },
      settled_datetime: "2023-05-27",
      manufacturer: "spectiv labs",
      brand_name: "Gitsy_327593",
      provider_text: "spectiv labs",
      status: {
        expired: 1,
      },
      access_type: "full_set_with_lock",
      link: "https://gitsyv2app.page.link/NCAMU3uBsiSzUhbW7",
    },
    {
      primary_purchase_gtins: [],
      primary_purchase_eans: [],
      deposited: 2,
      providers: ["radiansys.thecouponbureau.org", "spectivlabs.thecouponbureau.org"],
      rolling_expiration: 1,
      rolling_expiration_days: 7,
      settled: 0,
      finalized: 0,
      lookupcodes: [],
      allowed_retailers: [],
      settlement_email_sent: 1,
      primary_purchase_prefixed_code: ["PLU:radiansys.thecouponbureau.org:40"],
      timezone_val: "Pacific/Honolulu",
      create_date: "2023-09-07",
      internal_id: "bf48f783",
      approve_date: "2023-09-07",
      offer_code: "296840",
      base_gs1: "811200497900296840",
      email_domain: "spectivlabs.thecouponbureau.org",
      created_by_email_domain: "spectivlabs.thecouponbureau.org",
      brand_id: "17c666ba",
      description:
        "Get $5.25 off on minimum shopping of 10 units (test_product_5) at your nearest store till 7th October 2023",
      campaign_start_time: "2023-09-07",
      campaign_end_time: "2023-09-14",
      redemption_start_time: "2023-09-30",
      redemption_end_time: "2023-10-07",
      total_circulation: 1000,
      primary_purchase_save_value: 525,
      primary_purchase_requirements: 10,
      primary_purchase_req_code: 0,
      save_value_code: 0,
      store_coupon: 0,
      donot_multiply_flag: 1,
      executionId: "22acd2dc-151b-4071-9f91-fab25024918e",
      executedByEmail: "gitsyb2bapikeys_try@spectivlabs.thecouponbureau.org",
      update_datetime: 1694081665260,
      campaign_metadata: {
        allow_override: false,
        title: "Get $5.25 off",
        description:
          "Get $5.25 off on minimum shopping of 10 units (test_product_5) at your nearest store till 7th October 2023",
        terms: "https://thecouponbureau.org/terms",
        mobile_image_url:
          "https://gitsy-b2b-dev.s3.ap-south-1.amazonaws.com/01H6R1GGWD5HE1SSX4TKVYA106/product_image/1692606270139.1690193143490.Mask.png",
        desktop_image_url:
          "https://gitsy-b2b-dev.s3.ap-south-1.amazonaws.com/01H6R1GGWD5HE1SSX4TKVYA106/product_image/1692606270139.1690193143490.Mask.png",
        dollar_amount: 5.25,
      },
      manufacturer: "spectiv labs",
      brand_name: "test_brand_1",
      provider_text: "radiansys, spectiv labs",
      status: {
        expired: 1,
      },
      access_type: "full_set_with_lock",
      settled_in_hours: 90,
      link: "https://gitsyv2app.page.link/ZH9NobFUjH1CdYzk6",
      max_quantity_to_group: "1",
      max_limit_to_avail_offer: "Single",
    },
    {
      primary_purchase_gtins: [],
      primary_purchase_eans: [],
      second_purchase_gtins: [],
      second_purchase_eans: [],
      deposited: 17,
      providers: ["radiansys.thecouponbureau.org", "spectivlabs.thecouponbureau.org"],
      rolling_expiration: 1,
      rolling_expiration_days: 30,
      settled: 0,
      finalized: 0,
      lookupcodes: [],
      allowed_retailers: [],
      settlement_email_sent: 0,
      timezone_val: "Pacific/Honolulu",
      create_date: "2023-09-07",
      internal_id: "2260dd3c",
      approve_date: "2023-09-07",
      offer_code: "254939",
      base_gs1: "811200497900254939",
      email_domain: "spectivlabs.thecouponbureau.org",
      created_by_email_domain: "spectivlabs.thecouponbureau.org",
      brand_id: "b2872b67",
      description: "Buy 5 Coup Beans, get a FREE Coup Muffin",
      campaign_start_time: "2023-03-16",
      campaign_end_time: "2023-12-31",
      redemption_start_time: "2023-03-16",
      redemption_end_time: "2023-12-31",
      total_circulation: 10000,
      primary_purchase_save_value: 75,
      primary_purchase_requirements: 5,
      primary_purchase_req_code: 0,
      additional_purchase_rules_code: 1,
      second_purchase_requirements: 1,
      second_purchase_req_code: 0,
      save_value_code: 1,
      applies_to_which_item: 2,
      store_coupon: 0,
      donot_multiply_flag: 1,
      executionId: "e3c46525-1a82-4200-87e2-941bbed1d9c5",
      executedByEmail: "gitsyb2bapikeys_try@spectivlabs.thecouponbureau.org",
      update_datetime: 1694081603376,
      campaign_metadata: {
        allow_override: false,
        title: "COUPon 4",
        description: "Buy 5 Coup Beans, get a FREE Coup Muffin",
        terms: "https://thecouponbureau.org/terms",
        mobile_image_url: "https://gitsy-product-images.s3.amazonaws.com/muffin.png",
        desktop_image_url: "https://gitsy-product-images.s3.amazonaws.com/muffin.png",
        dollar_amount: 0.75,
      },
      manufacturer: "spectiv labs",
      brand_name: "test_brand_2",
      provider_text: "radiansys, spectiv labs",
      status: {
        locked: 1,
      },
      access_type: "full_set_with_lock",
      link: "https://gitsyv2app.page.link/DVRgUpRhG3487edZ6",
    },
    {
      primary_purchase_gtins: ["693719388547"],
      second_purchase_gtins: ["799739218991"],
      deposited: 70,
      providers: ["spectivlabs.thecouponbureau.org"],
      rolling_expiration: 1,
      rolling_expiration_days: 30,
      settled: 0,
      finalized: 0,
      lookupcodes: [],
      allowed_retailers: [],
      settlement_email_sent: 0,
      timezone_val: "Pacific/Honolulu",
      create_date: "2023-03-16",
      internal_id: "3da29cf3",
      approve_date: "2023-03-16",
      offer_code: "102729",
      base_gs1: "811200497900102729",
      email_domain: "spectivlabs.thecouponbureau.org",
      created_by_email_domain: "spectivlabs.thecouponbureau.org",
      brand_id: "12648298",
      description: "Buy 5 Gitsy Beans, get a FREE Gitsy Muffin",
      campaign_start_time: "2023-03-16",
      campaign_end_time: "2023-12-31",
      redemption_start_time: "2023-03-16",
      redemption_end_time: "2023-12-31",
      total_circulation: 10000,
      primary_purchase_save_value: 75,
      primary_purchase_requirements: 5,
      primary_purchase_req_code: 0,
      additional_purchase_rules_code: 1,
      second_purchase_requirements: 1,
      save_value_code: 1,
      applies_to_which_item: 2,
      store_coupon: 3,
      donot_multiply_flag: 4,
      executionId: "c953f045-3e82-4a7c-889c-50d12c5ed18a",
      executedByEmail: "148a7d730f1dd0a875aa09f39587c001@spectivlabs.thecouponbureau.org",
      update_datetime: 1691600238770,
      campaign_metadata: {
        allow_override: false,
        title: "COUPon 4",
        description: "Buy 5 Coup Beans, get a FREE Coup Muffin",
        terms: "https://thecouponbureau.org/terms",
        mobile_image_url: "https://gitsy-product-images.s3.amazonaws.com/muffin.png",
        desktop_image_url: "https://gitsy-product-images.s3.amazonaws.com/muffin.png",
        dollar_amount: 0.75,
      },
      redemption_days: {
        21: ["08:00-23:59"],
        monday: ["07:00-10:00", "15:00-23:30"],
        sunday: ["08:00-16:100"],
      },
      manufacturer: "spectiv labs",
      brand_name: "Gitsy_327593",
      provider_text: "spectiv labs",
      status: {
        locked: 1,
      },
      access_type: "full_set_with_lock",
      link: "https://gitsyv2app.page.link/VbZkEpWLUfbYkuDw9",
    },
    {
      primary_purchase_gtins: [],
      primary_purchase_eans: [],
      deposited: 0,
      providers: ["radiansys.thecouponbureau.org", "spectivlabs.thecouponbureau.org"],
      rolling_expiration: 1,
      rolling_expiration_days: 7,
      settled: 1,
      finalized: 0,
      lookupcodes: [],
      allowed_retailers: [],
      settlement_email_sent: 1,
      timezone_val: "Pacific/Honolulu",
      create_date: "2023-08-07",
      internal_id: "85adb743",
      approve_date: "2023-08-07",
      offer_code: "239127",
      base_gs1: "811200497900239127",
      email_domain: "spectivlabs.thecouponbureau.org",
      created_by_email_domain: "spectivlabs.thecouponbureau.org",
      brand_id: "d14b2ff1",
      description: "Get $10.00 Off on minimum shopping of 10 Unit () at your nearest store till 14th August 2023",
      campaign_start_time: "2023-08-07",
      campaign_end_time: "2023-08-14",
      redemption_start_time: "2023-08-07",
      redemption_end_time: "2023-08-14",
      total_circulation: 1000,
      primary_purchase_save_value: 1000,
      primary_purchase_requirements: 10,
      primary_purchase_req_code: 0,
      save_value_code: 0,
      donot_multiply_flag: 1,
      executionId: "b235d83f-f117-45d5-9202-48a72625c007",
      executedByEmail: "148a7d730f1dd0a875aa09f39587c001@spectivlabs.thecouponbureau.org",
      update_datetime: 1691496769740,
      campaign_metadata: {
        allow_override: false,
        title: "Get $10.00 Off",
        description: "Get $10.00 Off on minimum shopping of 10 Unit () at your nearest store till 14th August 2023",
        terms: "https://thecouponbureau.org/terms",
        dollar_amount: 10,
      },
      settled_datetime: "2023-08-23",
      manufacturer: "spectiv labs",
      brand_name: "spectiv_brand_1",
      provider_text: "radiansys, spectiv labs",
      status: {
        expired: 1,
      },
      access_type: "full_set_with_lock",
      link: "https://gitsyv2app.page.link/7zQpjdA4HzCb4Agc7",
    },
    {
      primary_purchase_gtins: ["037000488682"],
      deposited: 21,
      providers: ["spectivlabs.thecouponbureau.org"],
      rolling_expiration: 1,
      rolling_expiration_days: 10,
      settled: 1,
      finalized: 0,
      lookupcodes: [],
      allowed_retailers: [],
      settlement_email_sent: 1,
      timezone_val: "Pacific/Honolulu",
      create_date: "2023-06-23",
      internal_id: "cd70b810",
      approve_date: "2023-06-23",
      offer_code: "481521",
      base_gs1: "811200497900481521",
      email_domain: "spectivlabs.thecouponbureau.org",
      created_by_email_domain: "spectivlabs.thecouponbureau.org",
      brand_id: "a27ef0d5",
      description: "COUP $2.99 Off Bulk Baked Goods",
      campaign_start_time: "2023-06-22",
      campaign_end_time: "2023-09-30",
      redemption_start_time: "2023-06-22",
      redemption_end_time: "2023-09-30",
      total_circulation: 1000,
      primary_purchase_save_value: 299,
      primary_purchase_requirements: 3,
      primary_purchase_req_code: 0,
      donot_multiply_flag: 1,
      executionId: "837b4695-9cd2-47ec-93bf-dcf4c328769d",
      executedByEmail: "148a7d730f1dd0a875aa09f39587c001@spectivlabs.thecouponbureau.org",
      update_datetime: 1691496641841,
      campaign_metadata: {
        allow_override: false,
        title: "COUPon 3",
        description: "COUP $2.99 Off Bulk Baked Goods",
        terms: "https://thecouponbureau.org/terms",
        mobile_image_url:
          "https://firebasestorage.googleapis.com/v0/b/couponlink.appspot.com/o/images%2FDemoBreakfastBuscuit.png?alt=media&token=105e52ad-b100-463b-9150-ca66d2f619a3",
        desktop_image_url:
          "https://firebasestorage.googleapis.com/v0/b/couponlink.appspot.com/o/images%2FDemoBreakfastBuscuit.png?alt=media&token=105e52ad-b100-463b-9150-ca66d2f619a3",
        dollar_amount: 2.99,
      },
      settled_datetime: "2023-10-09",
      manufacturer: "spectiv labs",
      brand_name: "COUP",
      provider_text: "spectiv labs",
      status: {
        expired: 1,
      },
      access_type: "full_set_with_lock",
      link: "https://gitsyv2app.page.link/UtjJzXNE1tiPJJX5A",
    },
    {
      deposited: 16,
      providers: ["spectivlabs.thecouponbureau.org"],
      rolling_expiration: 1,
      rolling_expiration_days: 100,
      settled: 1,
      finalized: 0,
      lookupcodes: [],
      allowed_retailers: [],
      settlement_email_sent: 1,
      timezone_val: "Pacific/Honolulu",
      create_date: "2023-06-26",
      internal_id: "70ca3567",
      approve_date: "2023-06-26",
      offer_code: "481522",
      base_gs1: "811200497900481522",
      email_domain: "spectivlabs.thecouponbureau.org",
      created_by_email_domain: "spectivlabs.thecouponbureau.org",
      brand_id: "a27ef0d5",
      description: "COUP $0.50 Off any Baked Good",
      campaign_start_time: "2023-06-26",
      campaign_end_time: "2023-09-30",
      redemption_start_time: "2023-06-26",
      redemption_end_time: "2023-09-30",
      total_circulation: 1000,
      primary_purchase_save_value: 50,
      primary_purchase_requirements: 1,
      primary_purchase_req_code: 1,
      donot_multiply_flag: 1,
      executionId: "eccfbded-6bf3-4bd0-8db0-c8da21b1bd7a",
      executedByEmail: "148a7d730f1dd0a875aa09f39587c001@spectivlabs.thecouponbureau.org",
      update_datetime: 1691496599029,
      campaign_metadata: {
        allow_override: false,
        title: "COUPon 2",
        description: "COUP $0.50 Off any Baked Good",
        terms: "https://thecouponbureau.org/terms",
        mobile_image_url:
          "https://firebasestorage.googleapis.com/v0/b/couponlink.appspot.com/o/images%2FDemoCookies.png?alt=media&token=6baec3a1-0d62-4708-909d-48f5758b693b",
        desktop_image_url:
          "https://firebasestorage.googleapis.com/v0/b/couponlink.appspot.com/o/images%2FDemoCookies.png?alt=media&token=6baec3a1-0d62-4708-909d-48f5758b693b",
        dollar_amount: 0.5,
      },
      settled_datetime: "2023-10-09",
      manufacturer: "spectiv labs",
      brand_name: "COUP",
      provider_text: "spectiv labs",
      status: {
        expired: 1,
      },
      access_type: "full_set_with_lock",
      link: "https://gitsyv2app.page.link/5LF5i4kW1WJHEMuN8",
    },
    {
      deposited: 16,
      providers: ["spectivlabs.thecouponbureau.org"],
      rolling_expiration: 1,
      rolling_expiration_days: 100,
      settled: 1,
      finalized: 0,
      lookupcodes: [],
      allowed_retailers: [],
      settlement_email_sent: 1,
      timezone_val: "Pacific/Honolulu",
      create_date: "2023-06-26",
      internal_id: "9727731a",
      approve_date: "2023-06-26",
      offer_code: "481523",
      base_gs1: "811200497900481523",
      email_domain: "spectivlabs.thecouponbureau.org",
      created_by_email_domain: "spectivlabs.thecouponbureau.org",
      brand_id: "a27ef0d5",
      description: "COUP $1.99 Off any product",
      campaign_start_time: "2023-06-26",
      campaign_end_time: "2023-09-30",
      redemption_start_time: "2023-06-26",
      redemption_end_time: "2023-09-30",
      total_circulation: 1000,
      primary_purchase_save_value: 199,
      primary_purchase_requirements: 1,
      primary_purchase_req_code: 1,
      donot_multiply_flag: 1,
      executionId: "ca497260-be9b-4d4d-9a74-21bd9842d858",
      executedByEmail: "148a7d730f1dd0a875aa09f39587c001@spectivlabs.thecouponbureau.org",
      update_datetime: 1691496559513,
      campaign_metadata: {
        allow_override: false,
        title: "COUPon 1",
        description: "COUP $1.99 Off any product",
        terms: "https://thecouponbureau.org/terms",
        mobile_image_url:
          "https://firebasestorage.googleapis.com/v0/b/couponlink.appspot.com/o/images%2FDemoButter.png?alt=media&token=a0614692-bb54-41bb-87e8-edfb411a26e7",
        desktop_image_url:
          "https://firebasestorage.googleapis.com/v0/b/couponlink.appspot.com/o/images%2FDemoButter.png?alt=media&token=a0614692-bb54-41bb-87e8-edfb411a26e7",
        dollar_amount: 1.99,
      },
      settled_datetime: "2023-10-09",
      manufacturer: "spectiv labs",
      brand_name: "COUP",
      provider_text: "spectiv labs",
      status: {
        expired: 1,
      },
      access_type: "full_set_with_lock",
      link: "https://gitsyv2app.page.link/ESaRwgyk2FJUSEPJ8",
    },
    {
      primary_purchase_gtins: [],
      primary_purchase_eans: [],
      deposited: 0,
      providers: ["spectivlabs.thecouponbureau.org", "radiansys.thecouponbureau.org"],
      rolling_expiration: 0,
      settled: 0,
      finalized: 0,
      lookupcodes: [],
      allowed_retailers: [],
      settlement_email_sent: 0,
      timezone_val: "Pacific/Honolulu",
      create_date: "2023-08-07",
      internal_id: "e677f898",
      approve_date: "2023-08-07",
      offer_code: "601339",
      base_gs1: "811200497900601339",
      email_domain: "spectivlabs.thecouponbureau.org",
      created_by_email_domain: "spectivlabs.thecouponbureau.org",
      brand_id: "d14b2ff1",
      description: "$3 OFF per lb. Ribeye Steak – Limit 1 Pack",
      campaign_start_time: "2023-06-27",
      campaign_end_time: "2023-07-04",
      redemption_start_time: "2023-06-27",
      redemption_end_time: "2023-07-04",
      total_circulation: 1000,
      primary_purchase_save_value: 10,
      primary_purchase_requirements: 3,
      primary_purchase_req_code: 1,
      save_value_code: 2,
      store_coupon: 0,
      donot_multiply_flag: 1,
      executionId: "1425cbcb-2478-4106-bd66-3eaffb0e7828",
      executedByEmail: "gitsyb2bapikeys_try@spectivlabs.thecouponbureau.org",
      update_datetime: 1691391241803,
      campaign_metadata: {
        allow_override: false,
        title: "Save $3 per lb",
        description: "$3 OFF per lb. Ribeye Steak – Limit 1 Pack",
        terms: "https://thecouponbureau.org/terms",
        mobile_image_url: "https://spectivlabs.com/wp-content/uploads/2023/06/Ribeye-Steak_Lip-on.jpeg",
        desktop_image_url: "https://spectivlabs.com/wp-content/uploads/2023/06/Ribeye-Steak_Lip-on.jpeg",
        dollar_amount: 10,
      },
      manufacturer: "spectiv labs",
      brand_name: "spectiv_brand_1",
      provider_text: "spectiv labs, radiansys",
      status: {
        expired: 1,
      },
      access_type: "full_set_with_lock",
      link: "https://gitsyv2app.page.link/d3JmCB2WFuWP1pZ9A",
    },
    {
      primary_purchase_gtins: [],
      primary_purchase_eans: [],
      deposited: 0,
      providers: ["spectivlabs.thecouponbureau.org", "radiansys.thecouponbureau.org"],
      rolling_expiration: 0,
      settled: 0,
      finalized: 0,
      lookupcodes: [],
      allowed_retailers: [],
      settlement_email_sent: 0,
      timezone_val: "Pacific/Honolulu",
      create_date: "2023-08-07",
      internal_id: "5acc9eea",
      approve_date: "2023-08-07",
      offer_code: "488298",
      base_gs1: "811200497900488298",
      email_domain: "spectivlabs.thecouponbureau.org",
      created_by_email_domain: "spectivlabs.thecouponbureau.org",
      brand_id: "d14b2ff1",
      description: "$3 OFF per lb. Ribeye Steak – Limit 1 Pack",
      campaign_start_time: "2023-06-27",
      campaign_end_time: "2023-07-04",
      redemption_start_time: "2023-06-27",
      redemption_end_time: "2023-07-04",
      total_circulation: 1000,
      primary_purchase_save_value: 10,
      primary_purchase_requirements: 3,
      primary_purchase_req_code: 1,
      save_value_code: 2,
      store_coupon: 0,
      donot_multiply_flag: 1,
      executionId: "562d98df-dfa3-45ae-9471-879ace756eab",
      executedByEmail: "gitsyb2bapikeys_try@spectivlabs.thecouponbureau.org",
      update_datetime: 1691389069776,
      campaign_metadata: {
        allow_override: false,
        title: "Save $3 per lb",
        description: "$3 OFF per lb. Ribeye Steak – Limit 1 Pack",
        terms: "https://thecouponbureau.org/terms",
        mobile_image_url: "https://spectivlabs.com/wp-content/uploads/2023/06/Ribeye-Steak_Lip-on.jpeg",
        desktop_image_url: "https://spectivlabs.com/wp-content/uploads/2023/06/Ribeye-Steak_Lip-on.jpeg",
        dollar_amount: 10,
      },
      manufacturer: "spectiv labs",
      brand_name: "spectiv_brand_1",
      provider_text: "spectiv labs, radiansys",
      status: {
        expired: 1,
      },
      access_type: "full_set_with_lock",
      link: "https://gitsyv2app.page.link/UqnCNzrGWhQ8KfnY9",
    },
    {
      primary_purchase_gtins: [],
      primary_purchase_eans: [],
      deposited: 0,
      providers: ["spectivlabs.thecouponbureau.org", "radiansys.thecouponbureau.org"],
      rolling_expiration: 0,
      settled: 0,
      finalized: 0,
      lookupcodes: [],
      allowed_retailers: [],
      settlement_email_sent: 0,
      timezone_val: "Pacific/Honolulu",
      create_date: "2023-08-07",
      internal_id: "f0496748",
      approve_date: "2023-08-07",
      offer_code: "489437",
      base_gs1: "811200497900489437",
      email_domain: "spectivlabs.thecouponbureau.org",
      created_by_email_domain: "spectivlabs.thecouponbureau.org",
      brand_id: "d14b2ff1",
      description: "$3 OFF per lb. Ribeye Steak – Limit 1 Pack",
      campaign_start_time: "2023-06-27",
      campaign_end_time: "2023-07-04",
      redemption_start_time: "2023-06-27",
      redemption_end_time: "2023-07-04",
      total_circulation: 1000,
      primary_purchase_save_value: 3,
      primary_purchase_requirements: 3,
      primary_purchase_req_code: 1,
      save_value_code: 2,
      store_coupon: 0,
      donot_multiply_flag: 1,
      executionId: "a285ff54-cfd9-47eb-a571-c4387c82fc9d",
      executedByEmail: "gitsyb2bapikeys_try@spectivlabs.thecouponbureau.org",
      update_datetime: 1691387871779,
      campaign_metadata: {
        allow_override: false,
        title: "Save $3 per lb",
        description: "$3 OFF per lb. Ribeye Steak – Limit 1 Pack",
        terms: "https://thecouponbureau.org/terms",
        mobile_image_url: "https://spectivlabs.com/wp-content/uploads/2023/06/Ribeye-Steak_Lip-on.jpeg",
        desktop_image_url: "https://spectivlabs.com/wp-content/uploads/2023/06/Ribeye-Steak_Lip-on.jpeg",
        dollar_amount: 3,
      },
      manufacturer: "spectiv labs",
      brand_name: "spectiv_brand_1",
      provider_text: "spectiv labs, radiansys",
      status: {
        expired: 1,
      },
      access_type: "full_set_with_lock",
      link: "https://gitsyv2app.page.link/vqzEUrEeTyJZevR7A",
    },
    {
      primary_purchase_gtins: ["061414155557"],
      deposited: 10,
      providers: ["spectivlabs.thecouponbureau.org"],
      rolling_expiration: 1,
      rolling_expiration_days: 1,
      settled: 1,
      finalized: 0,
      lookupcodes: [],
      allowed_retailers: [],
      settlement_email_sent: 1,
      timezone_val: "Pacific/Honolulu",
      create_date: "2023-07-18",
      internal_id: "8b77eed6",
      approve_date: "2023-07-18",
      offer_code: "481518",
      base_gs1: "811200497900481518",
      email_domain: "spectivlabs.thecouponbureau.org",
      created_by_email_domain: "spectivlabs.thecouponbureau.org",
      brand_id: "5bd3444d",
      description: "test future campaigns",
      campaign_start_time: "2023-07-24",
      campaign_end_time: "2023-07-31",
      redemption_start_time: "2023-07-24",
      redemption_end_time: "2023-07-31",
      total_circulation: 100,
      primary_purchase_save_value: 100,
      primary_purchase_requirements: 1,
      primary_purchase_req_code: 0,
      donot_multiply_flag: 1,
      executionId: "886778a0-63f6-40c6-aae8-4c4c8d548a2f",
      executedByEmail: "148a7d730f1dd0a875aa09f39587c001@spectivlabs.thecouponbureau.org",
      update_datetime: 1689666901109,
      settled_datetime: "2023-08-09",
      manufacturer: "spectiv labs",
      brand_name: "Ramesh_Testing",
      provider_text: "spectiv labs",
      status: {
        expired: 1,
      },
      access_type: "full_set_with_lock",
      link: "https://gitsyv2app.page.link/N4huNnAyxBssCNbt9",
    },
    {
      primary_purchase_gtins: ["234861000002"],
      deposited: 1,
      providers: ["radiansys.thecouponbureau.org", "spectivlabs.thecouponbureau.org"],
      rolling_expiration: 0,
      settled: 1,
      finalized: 0,
      lookupcodes: [],
      allowed_retailers: [],
      settlement_email_sent: 1,
      primary_purchase_prefixed_code: ["PLU:sparkle-cs.com:989"],
      timezone_val: "Pacific/Honolulu",
      create_date: "2023-06-27",
      internal_id: "76ebe95c",
      approve_date: "2023-06-27",
      offer_code: "481517",
      base_gs1: "811200497900481517",
      email_domain: "spectivlabs.thecouponbureau.org",
      created_by_email_domain: "spectivlabs.thecouponbureau.org",
      brand_id: "12648298",
      description: "$3 OFF per lb. Ribeye Steak – Limit 1 Pack",
      campaign_start_time: "2023-06-27",
      campaign_end_time: "2023-07-04",
      redemption_start_time: "2023-06-27",
      redemption_end_time: "2023-07-04",
      total_circulation: 1000,
      primary_purchase_save_value: 300,
      primary_purchase_requirements: 300,
      primary_purchase_req_code: 1,
      executionId: "eaa6f94f-6049-489d-b8d6-1a5b48cad904",
      executedByEmail: "148a7d730f1dd0a875aa09f39587c001@spectivlabs.thecouponbureau.org",
      update_datetime: 1687877230552,
      campaign_metadata: {
        allow_override: false,
        title: "Save $3 per lb",
        description: "$3 OFF per lb. Ribeye Steak – Limit 1 Pack",
        terms: "https://thecouponbureau.org/terms",
        mobile_image_url: "https://spectivlabs.com/wp-content/uploads/2023/06/Ribeye-Steak_Lip-on.jpeg",
        desktop_image_url: "https://spectivlabs.com/wp-content/uploads/2023/06/Ribeye-Steak_Lip-on.jpeg",
        dollar_amount: 3,
      },
      settled_datetime: "2023-07-13",
      manufacturer: "spectiv labs",
      brand_name: "Gitsy_327593",
      provider_text: "radiansys, spectiv labs",
      status: {
        expired: 1,
      },
      access_type: "full_set_with_lock",
      link: "https://gitsyv2app.page.link/x3EYwzK5uFUUW2xJ9",
    },
    {
      primary_purchase_gtins: ["234861000002"],
      deposited: 4,
      providers: ["radiansys.thecouponbureau.org", "spectivlabs.thecouponbureau.org"],
      rolling_expiration: 0,
      settled: 1,
      finalized: 0,
      lookupcodes: [],
      allowed_retailers: ["sparkle-cs.com"],
      settlement_email_sent: 1,
      primary_purchase_prefixed_code: ["PLU:sparkle-cs.com:989"],
      timezone_val: "Pacific/Honolulu",
      create_date: "2023-06-22",
      internal_id: "d23169b2",
      approve_date: "2023-06-22",
      offer_code: "481516",
      base_gs1: "811200497900481516",
      email_domain: "spectivlabs.thecouponbureau.org",
      created_by_email_domain: "spectivlabs.thecouponbureau.org",
      brand_id: "12648298",
      description: "$1 OFF per lb. Baby Back Ribs – Limit 1 Pack",
      campaign_start_time: "2023-06-22",
      campaign_end_time: "2023-07-04",
      redemption_start_time: "2023-06-22",
      redemption_end_time: "2023-07-04",
      total_circulation: 5000,
      primary_purchase_save_value: 100,
      primary_purchase_requirements: 100,
      primary_purchase_req_code: 1,
      executionId: "20b12e49-5e03-412c-b015-9f3d0bdff8d0",
      executedByEmail: "148a7d730f1dd0a875aa09f39587c001@spectivlabs.thecouponbureau.org",
      update_datetime: 1687725339995,
      campaign_metadata: {
        allow_override: false,
        title: "Save $1",
        description: "$1 OFF per lb. Baby Back Ribs – Limit 1 Pack",
        terms: "https://thecouponbureau.org/terms",
        mobile_image_url: "https://spectivlabs.com/wp-content/uploads/2023/06/baby-back-ribs.jpg",
        desktop_image_url: "https://spectivlabs.com/wp-content/uploads/2023/06/baby-back-ribs.jpg",
        dollar_amount: 1,
      },
      settled_datetime: "2023-07-13",
      manufacturer: "spectiv labs",
      brand_name: "Gitsy_327593",
      provider_text: "radiansys, spectiv labs",
      status: {
        expired: 1,
      },
      access_type: "full_set_with_lock",
      link: "https://gitsyv2app.page.link/VMchVd1wvNgp1xN39",
    },
    {
      primary_purchase_gtins: ["061414155557"],
      second_purchase_gtins: ["061414155557"],
      second_purchase_eans: [],
      third_purchase_gtins: ["061414155557"],
      third_purchase_eans: [],
      deposited: 10,
      providers: ["spectivlabs.thecouponbureau.org"],
      rolling_expiration: 1,
      rolling_expiration_days: 100,
      settled: 1,
      finalized: 0,
      lookupcodes: [],
      allowed_retailers: [],
      settlement_email_sent: 1,
      timezone_val: "Pacific/Honolulu",
      create_date: "2023-04-17",
      internal_id: "e5c0c976",
      approve_date: "2023-04-17",
      offer_code: "183662",
      base_gs1: "811200497900183662",
      email_domain: "spectivlabs.thecouponbureau.org",
      created_by_email_domain: "spectivlabs.thecouponbureau.org",
      brand_id: "5bd3444d",
      description: "Gitsy V2 1.0.1 Testing 16$ Off",
      campaign_start_time: "2023-04-16",
      campaign_end_time: "2023-07-26",
      redemption_start_time: "2023-04-16",
      redemption_end_time: "2023-07-26",
      total_circulation: 10000000,
      primary_purchase_save_value: 1,
      primary_purchase_requirements: 1,
      primary_purchase_req_code: 1,
      additional_purchase_rules_code: 1,
      second_purchase_requirements: 1,
      second_purchase_gs1_company_prefix: 1,
      second_purchase_req_code: 1,
      third_purchase_requirements: 1,
      third_purchase_gs1_company_prefix: 1,
      third_purchase_req_code: 1,
      save_value_code: 1,
      applies_to_which_item: 1,
      donot_multiply_flag: 1,
      executionId: "a7375b67-561e-4ffb-a1aa-bd94291c0791",
      executedByEmail: "148a7d730f1dd0a875aa09f39587c001@spectivlabs.thecouponbureau.org",
      update_datetime: 1683954413860,
      campaign_metadata: {
        allow_override: false,
        title: "16$ Off",
        description: "Gitsy V2 1.0.1 Testing",
        terms: "https://thecouponbureau.org/terms",
        mobile_image_url: "https://tcb-static.s3.us-east-1.amazonaws.com/gitsy/gitsy_milk.png",
        desktop_image_url: "https://tcb-static.s3.us-east-1.amazonaws.com/gitsy/gitsy_milk.png",
        dollar_amount: 16,
      },
      primary_purchase_eans: [],
      settled_datetime: "2023-08-04",
      manufacturer: "spectiv labs",
      brand_name: "Ramesh_Testing",
      provider_text: "spectiv labs",
      status: {
        expired: 1,
      },
      access_type: "full_set_with_lock",
      link: "https://gitsyv2app.page.link/g5DjKHvMLXVQPphC6",
    },
    {
      primary_purchase_gtins: ["061414155557"],
      deposited: 4468,
      providers: ["spectivlabs.thecouponbureau.org"],
      rolling_expiration: 1,
      rolling_expiration_days: 1,
      settled: 0,
      finalized: 0,
      lookupcodes: [],
      allowed_retailers: [],
      settlement_email_sent: 0,
      timezone_val: "Pacific/Honolulu",
      create_date: "2023-02-28",
      internal_id: "f6a2714d",
      approve_date: "2023-02-28",
      offer_code: "111111",
      base_gs1: "811200497900111111",
      email_domain: "spectivlabs.thecouponbureau.org",
      created_by_email_domain: "spectivlabs.thecouponbureau.org",
      brand_id: "12648298",
      description: "Gitsy Status Page",
      campaign_start_time: "2023-02-27",
      campaign_end_time: "2024-02-29",
      redemption_start_time: "2023-02-27",
      redemption_end_time: "2024-02-29",
      total_circulation: 10000000,
      primary_purchase_save_value: 1,
      primary_purchase_requirements: 1,
      primary_purchase_req_code: 1,
      executionId: "5995852f-97f3-4805-a838-5f9c07fd07a4",
      executedByEmail: "148a7d730f1dd0a875aa09f39587c001@spectivlabs.thecouponbureau.org",
      update_datetime: 1683625881247,
      campaign_metadata: {
        allow_override: false,
        title: "12$ Off",
        description: "Gitsy 1.2.5 Testing",
        terms: "https://thecouponbureau.org/terms",
        mobile_image_url: "https://tcb-static.s3.us-east-1.amazonaws.com/gitsy/gitsy_milk.png",
        desktop_image_url: "https://tcb-static.s3.us-east-1.amazonaws.com/gitsy/gitsy_milk.png",
        dollar_amount: 12,
      },
      manufacturer: "spectiv labs",
      brand_name: "Gitsy_327593",
      provider_text: "spectiv labs",
      status: {
        locked: 1,
      },
      access_type: "full_set_with_lock",
      link: "https://gitsyv2app.page.link/KnyXj9dgfkiBdkWM8",
    },
    {
      primary_purchase_gtins: ["061414155557"],
      deposited: 0,
      providers: ["spectivlabs.thecouponbureau.org", "qples.com"],
      rolling_expiration: 1,
      rolling_expiration_days: 1,
      settled: 1,
      finalized: 0,
      lookupcodes: [],
      allowed_retailers: [],
      settlement_email_sent: 1,
      timezone_val: "Pacific/Honolulu",
      create_date: "2023-03-23",
      internal_id: "9228245b",
      approve_date: "2023-03-23",
      offer_code: "222222",
      base_gs1: "811200497900222222",
      email_domain: "spectivlabs.thecouponbureau.org",
      created_by_email_domain: "spectivlabs.thecouponbureau.org",
      brand_id: "12648298",
      description: "No Campaign Data update check",
      campaign_start_time: "2023-03-22",
      campaign_end_time: "2023-03-31",
      redemption_start_time: "2023-03-22",
      redemption_end_time: "2023-03-31",
      total_circulation: 100,
      primary_purchase_save_value: 1,
      primary_purchase_requirements: 1,
      primary_purchase_req_code: 1,
      executionId: "9f7956e5-c702-495a-9893-dd7e3625481c",
      executedByEmail: "gitsy_try@spectivlabs.thecouponbureau.org",
      update_datetime: 1679985348327,
      settled_datetime: "2023-04-09",
      manufacturer: "spectiv labs",
      brand_name: "Gitsy_327593",
      provider_text: "spectiv labs, Qples",
      status: {
        expired: 1,
      },
      access_type: "full_set_with_lock",
      link: "https://gitsyv2app.page.link/mBegJA8gunUTn5fz9",
    },
    {
      primary_purchase_gtins: ["758084613356"],
      deposited: 9,
      providers: ["spectivlabs.thecouponbureau.org"],
      settled: 0,
      finalized: 0,
      lookupcodes: [],
      allowed_retailers: [],
      settlement_email_sent: 0,
      timezone_val: "Pacific/Honolulu",
      create_date: "2023-03-14",
      internal_id: "1e1ef5e5",
      approve_date: "2023-03-14",
      offer_code: "042768",
      base_gs1: "811200497900042768",
      email_domain: "spectivlabs.thecouponbureau.org",
      created_by_email_domain: "spectivlabs.thecouponbureau.org",
      brand_id: "12648298",
      description: "Gitsy Deli Soup",
      campaign_start_time: "2023-03-14",
      campaign_end_time: "2023-12-31",
      redemption_start_time: "2023-03-14",
      redemption_end_time: "2023-12-31",
      total_circulation: 10000,
      primary_purchase_save_value: 100,
      primary_purchase_requirements: 1,
      primary_purchase_req_code: 0,
      executionId: "d9d84fbf-1ff9-40bc-b20d-ac47c3c8cc13",
      executedByEmail: "148a7d730f1dd0a875aa09f39587c001@spectivlabs.thecouponbureau.org",
      update_datetime: 1679073203927,
      campaign_metadata: {
        allow_override: false,
        title: "Save $1",
        description: "Gitsy Deli Soup",
        terms: "https://thecouponbureau.org/terms",
        mobile_image_url: "https://gitsy-product-images.s3.amazonaws.com/gitsy_deli_soup.png",
        desktop_image_url: "https://gitsy-product-images.s3.amazonaws.com/gitsy_deli_soup.png",
        dollar_amount: 1,
      },
      manufacturer: "spectiv labs",
      brand_name: "Gitsy_327593",
      provider_text: "spectiv labs",
      status: {
        locked: 1,
      },
      access_type: "full_set_with_lock",
      link: "https://gitsyv2app.page.link/28Ha7X7GQNT3mCbc8",
    },
    {
      primary_purchase_gtins: ["728374809264"],
      second_purchase_gtins: ["738374609269"],
      deposited: 21,
      providers: ["spectivlabs.thecouponbureau.org"],
      rolling_expiration: 1,
      rolling_expiration_days: 30,
      settled: 0,
      finalized: 0,
      lookupcodes: [],
      allowed_retailers: [],
      settlement_email_sent: 0,
      timezone_val: "Pacific/Honolulu",
      create_date: "2023-03-16",
      internal_id: "4ac3ae5b",
      approve_date: "2023-03-16",
      offer_code: "011149",
      base_gs1: "811200497900011149",
      email_domain: "spectivlabs.thecouponbureau.org",
      created_by_email_domain: "spectivlabs.thecouponbureau.org",
      brand_id: "12648298",
      description: "Buy 2 Gitsy O's Cereal, save $3 on Gitsy Milk",
      campaign_start_time: "2023-03-16",
      campaign_end_time: "2023-12-31",
      redemption_start_time: "2023-03-16",
      redemption_end_time: "2023-12-31",
      total_circulation: 10000,
      primary_purchase_save_value: 300,
      primary_purchase_requirements: 2,
      primary_purchase_req_code: 0,
      additional_purchase_rules_code: 1,
      second_purchase_requirements: 1,
      save_value_code: 1,
      applies_to_which_item: 1,
      executionId: "c37575e9-1321-4fed-8b58-f73e5f976d06",
      executedByEmail: "148a7d730f1dd0a875aa09f39587c001@spectivlabs.thecouponbureau.org",
      update_datetime: 1679070549738,
      campaign_metadata: {
        allow_override: false,
        title: "Buy 2 Gitsy Cereal, Save $3 on Gitsy Milk",
        description: "Buy 2 Gitsy Cereal, Save $3 on Gitsy Milk",
        terms: "https://thecouponbureau.org/terms",
        mobile_image_url: "https://gitsy-product-images.s3.amazonaws.com/gitsy_milk.png",
        desktop_image_url: "https://gitsy-product-images.s3.amazonaws.com/gitsy_milk.png",
        dollar_amount: 3,
      },
      manufacturer: "spectiv labs",
      brand_name: "Gitsy_327593",
      provider_text: "spectiv labs",
      status: {
        locked: 1,
      },
      access_type: "full_set_with_lock",
      link: "https://gitsyv2app.page.link/KoE9ghyYXpPfGDpXA",
    },
    {
      primary_purchase_gtins: ["728374809264"],
      deposited: 21,
      providers: ["spectivlabs.thecouponbureau.org"],
      settled: 1,
      finalized: 0,
      lookupcodes: [],
      allowed_retailers: [],
      settlement_email_sent: 1,
      create_date: "2023-02-23",
      internal_id: "357eb41a",
      approve_date: "2023-02-23",
      offer_code: "012018",
      base_gs1: "811200497900012018",
      email_domain: "spectivlabs.thecouponbureau.org",
      created_by_email_domain: "spectivlabs.thecouponbureau.org",
      brand_id: "12648298",
      description: "Gitsy O's Cereal",
      campaign_start_time: "2023-02-22",
      campaign_end_time: "2023-05-22",
      redemption_start_time: "2023-02-22",
      redemption_end_time: "2023-05-22",
      total_circulation: 10000,
      primary_purchase_save_value: 250,
      primary_purchase_requirements: 1,
      primary_purchase_req_code: 0,
      executionId: "0f4c41c2-0400-4761-87a1-b01a0dcd7246",
      executedByEmail: "148a7d730f1dd0a875aa09f39587c001@spectivlabs.thecouponbureau.org",
      update_datetime: 1679070456975,
      campaign_metadata: {
        allow_override: false,
        title: "Save $2.50",
        description: "GITSY O'S CEREAL: save on any Gitsy cereal product ",
        terms: "https://thecouponbureau.org/terms",
        mobile_image_url: "https://gitsy-product-images.s3.amazonaws.com/gitsy_os.png",
        desktop_image_url: "https://gitsy-product-images.s3.amazonaws.com/gitsy_os.png",
        dollar_amount: 2.5,
      },
      timezone_val: "Pacific/Honolulu",
      settled_datetime: "2023-05-31",
      manufacturer: "spectiv labs",
      brand_name: "Gitsy_327593",
      provider_text: "spectiv labs",
      status: {
        expired: 1,
      },
      access_type: "full_set_with_lock",
      link: "https://gitsyv2app.page.link/ddb2Ph3PqZVqjWwG6",
    },
    {
      primary_purchase_gtins: ["738374609269"],
      deposited: 50,
      providers: ["spectivlabs.thecouponbureau.org"],
      settled: 1,
      finalized: 0,
      lookupcodes: [],
      allowed_retailers: [],
      settlement_email_sent: 1,
      create_date: "2023-02-23",
      internal_id: "744c19b6",
      approve_date: "2023-02-23",
      offer_code: "031120",
      base_gs1: "811200497900031120",
      email_domain: "spectivlabs.thecouponbureau.org",
      created_by_email_domain: "spectivlabs.thecouponbureau.org",
      brand_id: "12648298",
      description: "Gitsy Whole Milk: save on any size Gitsy milk product",
      campaign_start_time: "2023-02-22",
      campaign_end_time: "2023-05-22",
      redemption_start_time: "2023-02-22",
      redemption_end_time: "2023-05-22",
      total_circulation: 10000,
      primary_purchase_save_value: 400,
      primary_purchase_requirements: 1,
      primary_purchase_req_code: 0,
      executionId: "f619f15b-06ae-45df-8601-69fdef9f3c57",
      executedByEmail: "148a7d730f1dd0a875aa09f39587c001@spectivlabs.thecouponbureau.org",
      update_datetime: 1679070450794,
      campaign_metadata: {
        allow_override: false,
        title: "Save $4",
        description: "GITSY WHOLE MILK: save on any size Gitsy milk product",
        terms: "https://thecouponbureau.org/terms",
        mobile_image_url: "https://gitsy-product-images.s3.amazonaws.com/gitsy_milk.png",
        desktop_image_url: "https://gitsy-product-images.s3.amazonaws.com/gitsy_milk.png",
        dollar_amount: 4,
      },
      timezone_val: "Pacific/Honolulu",
      settled_datetime: "2023-05-31",
      manufacturer: "spectiv labs",
      brand_name: "Gitsy_327593",
      provider_text: "spectiv labs",
      status: {
        expired: 1,
      },
      access_type: "full_set_with_lock",
      link: "https://gitsyv2app.page.link/kEEjGDB3oNeRtiTH9",
    },
    {
      primary_purchase_gtins: ["061414155557"],
      deposited: 15,
      providers: ["spectivlabs.thecouponbureau.org"],
      rolling_expiration: 1,
      rolling_expiration_days: 30,
      settled: 0,
      finalized: 0,
      lookupcodes: [],
      allowed_retailers: [],
      settlement_email_sent: 0,
      timezone_val: "Pacific/Honolulu",
      create_date: "2023-03-16",
      internal_id: "43481a29",
      approve_date: "2023-03-16",
      offer_code: "010452",
      base_gs1: "811200497900010452",
      email_domain: "spectivlabs.thecouponbureau.org",
      created_by_email_domain: "spectivlabs.thecouponbureau.org",
      brand_id: "12648298",
      description: "Buy 1 Gitsy Cola, Get 1 FREE",
      campaign_start_time: "2023-03-16",
      campaign_end_time: "2023-12-31",
      redemption_start_time: "2023-03-16",
      redemption_end_time: "2023-12-31",
      total_circulation: 10000,
      primary_purchase_save_value: 699,
      primary_purchase_requirements: 2,
      primary_purchase_req_code: 0,
      save_value_code: 1,
      executionId: "e1a76c9f-0345-4191-b4aa-aa0c8f686674",
      executedByEmail: "148a7d730f1dd0a875aa09f39587c001@spectivlabs.thecouponbureau.org",
      update_datetime: 1679070444276,
      campaign_metadata: {
        allow_override: false,
        title: "Buy One, Get One ",
        description: "Buy 1 Gitsy Cola, Get 1 FREE",
        terms: "https://thecouponbureau.org/terms",
        mobile_image_url: "https://tcb-static.s3.us-east-1.amazonaws.com/gitsy/gitsy_cola.jpg",
        desktop_image_url: "https://tcb-static.s3.us-east-1.amazonaws.com/gitsy/gitsy_cola.jpg",
        dollar_amount: 6.99,
      },
      manufacturer: "spectiv labs",
      brand_name: "Gitsy_327593",
      provider_text: "spectiv labs",
      status: {
        locked: 1,
      },
      access_type: "full_set_with_lock",
      link: "https://gitsyv2app.page.link/ftBJXPTkFMsr7Ytc9",
    },
    {
      primary_purchase_gtins: ["693719388547"],
      deposited: 6,
      providers: ["spectivlabs.thecouponbureau.org"],
      settled: 0,
      finalized: 0,
      lookupcodes: [],
      allowed_retailers: [],
      settlement_email_sent: 0,
      timezone_val: "Pacific/Honolulu",
      create_date: "2023-03-14",
      internal_id: "647d4239",
      approve_date: "2023-03-14",
      offer_code: "122282",
      base_gs1: "811200497900122282",
      email_domain: "spectivlabs.thecouponbureau.org",
      created_by_email_domain: "spectivlabs.thecouponbureau.org",
      brand_id: "12648298",
      description: "Gitsy Beans",
      campaign_start_time: "2023-03-14",
      campaign_end_time: "2023-12-31",
      redemption_start_time: "2023-03-14",
      redemption_end_time: "2023-12-31",
      total_circulation: 10000,
      primary_purchase_save_value: 100,
      primary_purchase_requirements: 1,
      primary_purchase_req_code: 0,
      executionId: "c2a1f942-586b-4cf9-b383-20a583b2526c",
      executedByEmail: "148a7d730f1dd0a875aa09f39587c001@spectivlabs.thecouponbureau.org",
      update_datetime: 1679062418773,
      campaign_metadata: {
        allow_override: false,
        title: "Save $1",
        description: "Gitsy Beans",
        terms: "https://thecouponbureau.org/terms",
        mobile_image_url: "https://gitsy-product-images.s3.amazonaws.com/gitsy_beans.png",
        desktop_image_url: "https://gitsy-product-images.s3.amazonaws.com/gitsy_beans.png",
        dollar_amount: 1,
      },
      manufacturer: "spectiv labs",
      brand_name: "Gitsy_327593",
      provider_text: "spectiv labs",
      status: {
        locked: 1,
      },
      access_type: "full_set_with_lock",
      link: "https://gitsyv2app.page.link/rRXKyAY53h2HxkR47",
    },
    {
      primary_purchase_gtins: ["103893319492"],
      deposited: 21,
      providers: ["spectivlabs.thecouponbureau.org"],
      settled: 0,
      finalized: 0,
      lookupcodes: [],
      allowed_retailers: [],
      settlement_email_sent: 0,
      timezone_val: "Pacific/Honolulu",
      create_date: "2023-03-14",
      internal_id: "1a2527a3",
      approve_date: "2023-03-14",
      offer_code: "033186",
      base_gs1: "811200497900033186",
      email_domain: "spectivlabs.thecouponbureau.org",
      created_by_email_domain: "spectivlabs.thecouponbureau.org",
      brand_id: "12648298",
      description: "Gitsy Goods",
      campaign_start_time: "2023-03-14",
      campaign_end_time: "2023-12-31",
      redemption_start_time: "2023-03-14",
      redemption_end_time: "2023-12-31",
      total_circulation: 10000,
      primary_purchase_save_value: 200,
      primary_purchase_requirements: 1,
      primary_purchase_req_code: 0,
      executionId: "9a8fe6e9-4d15-48c0-9fc4-e8820f013766",
      executedByEmail: "148a7d730f1dd0a875aa09f39587c001@spectivlabs.thecouponbureau.org",
      update_datetime: 1679062390631,
      campaign_metadata: {
        allow_override: false,
        title: "Save $2",
        description: "Gitsy Goods",
        terms: "https://thecouponbureau.org/terms",
        mobile_image_url: "https://gitsy-product-images.s3.amazonaws.com/gitsy_goods.png",
        desktop_image_url: "https://gitsy-product-images.s3.amazonaws.com/gitsy_goods.png",
        dollar_amount: 2,
      },
      manufacturer: "spectiv labs",
      brand_name: "Gitsy_327593",
      provider_text: "spectiv labs",
      status: {
        locked: 1,
      },
      access_type: "full_set_with_lock",
      link: "https://gitsyv2app.page.link/t5D7PNHaqkXsUoP89",
    },
    {
      primary_purchase_gtins: ["799739218991"],
      deposited: 12,
      providers: ["spectivlabs.thecouponbureau.org"],
      settled: 0,
      finalized: 0,
      lookupcodes: [],
      allowed_retailers: [],
      settlement_email_sent: 0,
      timezone_val: "Pacific/Honolulu",
      create_date: "2023-03-14",
      internal_id: "2d4b265f",
      approve_date: "2023-03-14",
      offer_code: "111798",
      base_gs1: "811200497900111798",
      email_domain: "spectivlabs.thecouponbureau.org",
      created_by_email_domain: "spectivlabs.thecouponbureau.org",
      brand_id: "12648298",
      description: "Gitsy Muffin",
      campaign_start_time: "2023-03-14",
      campaign_end_time: "2023-12-31",
      redemption_start_time: "2023-03-14",
      redemption_end_time: "2023-12-31",
      total_circulation: 10000,
      primary_purchase_save_value: 75,
      primary_purchase_requirements: 1,
      primary_purchase_req_code: 0,
      executionId: "88e2e407-e76b-4269-ad0c-310dc18ddf29",
      executedByEmail: "148a7d730f1dd0a875aa09f39587c001@spectivlabs.thecouponbureau.org",
      update_datetime: 1679062368387,
      campaign_metadata: {
        allow_override: false,
        title: "Save $0.75",
        description: "Gitsy Muffin",
        terms: "https://thecouponbureau.org/terms",
        mobile_image_url: "https://gitsy-product-images.s3.amazonaws.com/gitsy_muffin.png",
        desktop_image_url: "https://gitsy-product-images.s3.amazonaws.com/gitsy_muffin.png",
        dollar_amount: 0.75,
      },
      manufacturer: "spectiv labs",
      brand_name: "Gitsy_327593",
      provider_text: "spectiv labs",
      status: {
        locked: 1,
      },
      access_type: "full_set_with_lock",
      link: "https://gitsyv2app.page.link/8DWBWPUgFgMJjnRK6",
    },
    {
      primary_purchase_gtins: ["974933810077"],
      deposited: 31,
      providers: ["spectivlabs.thecouponbureau.org"],
      settled: 0,
      finalized: 0,
      lookupcodes: [],
      allowed_retailers: [],
      settlement_email_sent: 0,
      timezone_val: "Pacific/Honolulu",
      create_date: "2023-03-14",
      internal_id: "2152a4d8",
      approve_date: "2023-03-14",
      offer_code: "012884",
      base_gs1: "811200497900012884",
      email_domain: "spectivlabs.thecouponbureau.org",
      created_by_email_domain: "spectivlabs.thecouponbureau.org",
      brand_id: "12648298",
      description: "Gitsy Salad",
      campaign_start_time: "2023-03-14",
      campaign_end_time: "2023-12-31",
      redemption_start_time: "2023-03-14",
      redemption_end_time: "2023-12-31",
      total_circulation: 10000,
      primary_purchase_save_value: 300,
      primary_purchase_requirements: 1,
      primary_purchase_req_code: 0,
      executionId: "ad912eff-fdfd-40c6-9127-db749e354f9e",
      executedByEmail: "148a7d730f1dd0a875aa09f39587c001@spectivlabs.thecouponbureau.org",
      update_datetime: 1679062348830,
      campaign_metadata: {
        allow_override: false,
        title: "Save $3",
        description: "Gitsy Salad",
        terms: "https://thecouponbureau.org/terms",
        mobile_image_url: "https://gitsy-product-images.s3.amazonaws.com/gitsy_salad.png",
        desktop_image_url: "https://gitsy-product-images.s3.amazonaws.com/gitsy_salad.png",
        dollar_amount: 3,
      },
      manufacturer: "spectiv labs",
      brand_name: "Gitsy_327593",
      provider_text: "spectiv labs",
      status: {
        locked: 1,
      },
      access_type: "full_set_with_lock",
      link: "https://gitsyv2app.page.link/DBXXMPi2QRa3onyJ8",
    },
    {
      primary_purchase_gtins: ["973910384754"],
      deposited: 5,
      providers: ["spectivlabs.thecouponbureau.org"],
      settled: 0,
      finalized: 0,
      lookupcodes: [],
      allowed_retailers: [],
      settlement_email_sent: 0,
      timezone_val: "Pacific/Honolulu",
      create_date: "2023-03-14",
      internal_id: "30a64112",
      approve_date: "2023-03-14",
      offer_code: "060674",
      base_gs1: "811200497900060674",
      email_domain: "spectivlabs.thecouponbureau.org",
      created_by_email_domain: "spectivlabs.thecouponbureau.org",
      brand_id: "12648298",
      description: "Gitsy Hard Seltzer",
      campaign_start_time: "2023-03-14",
      campaign_end_time: "2023-12-31",
      redemption_start_time: "2023-03-14",
      redemption_end_time: "2023-12-31",
      total_circulation: 10000,
      primary_purchase_save_value: 500,
      primary_purchase_requirements: 1,
      primary_purchase_req_code: 0,
      executionId: "c7b45706-dab8-4633-8150-43acc8c4806b",
      executedByEmail: "148a7d730f1dd0a875aa09f39587c001@spectivlabs.thecouponbureau.org",
      update_datetime: 1679062321142,
      campaign_metadata: {
        allow_override: false,
        title: "Save $5",
        description: "Gitsy Hard Seltzer 6-Pack",
        terms: "https://thecouponbureau.org/terms",
        mobile_image_url: "https://gitsy-product-images.s3.amazonaws.com/gitsy_seltzer.png",
        desktop_image_url: "https://gitsy-product-images.s3.amazonaws.com/gitsy_seltzer.png",
        dollar_amount: 5,
      },
      manufacturer: "spectiv labs",
      brand_name: "Gitsy_327593",
      provider_text: "spectiv labs",
      status: {
        locked: 1,
      },
      access_type: "full_set_with_lock",
      link: "https://gitsyv2app.page.link/XvgYvzteZb3SNDPHA",
    },
    {
      primary_purchase_gtins: ["379729955343"],
      deposited: 7,
      providers: ["spectivlabs.thecouponbureau.org"],
      settled: 0,
      finalized: 0,
      lookupcodes: [],
      allowed_retailers: [],
      settlement_email_sent: 0,
      timezone_val: "Pacific/Honolulu",
      create_date: "2023-03-14",
      internal_id: "43bbb1cf",
      approve_date: "2023-03-14",
      offer_code: "070402",
      base_gs1: "811210497900070402",
      email_domain: "spectivlabs.thecouponbureau.org",
      created_by_email_domain: "spectivlabs.thecouponbureau.org",
      brand_id: "12648298",
      description: "Gitsy Vape",
      campaign_start_time: "2023-03-14",
      campaign_end_time: "2023-12-31",
      redemption_start_time: "2023-03-14",
      redemption_end_time: "2023-12-31",
      total_circulation: 10000,
      primary_purchase_save_value: 700,
      primary_purchase_requirements: 1,
      primary_purchase_req_code: 0,
      executionId: "8b9b5f12-fdc3-468a-987f-b8fc3e105c42",
      executedByEmail: "148a7d730f1dd0a875aa09f39587c001@spectivlabs.thecouponbureau.org",
      update_datetime: 1679062300382,
      campaign_metadata: {
        allow_override: false,
        title: "Save $7",
        description: "Gitsy Vape",
        terms: "https://thecouponbureau.org/terms",
        mobile_image_url: "https://gitsy-product-images.s3.amazonaws.com/gitsy_vape.png",
        desktop_image_url: "https://gitsy-product-images.s3.amazonaws.com/gitsy_vape.png",
        dollar_amount: 7,
      },
      manufacturer: "spectiv labs",
      brand_name: "Gitsy_327593",
      provider_text: "spectiv labs",
      status: {
        locked: 1,
      },
      access_type: "full_set_with_lock",
      link: "https://gitsyv2app.page.link/QhDBNPzKkjK5AjY39",
    },
    {
      primary_purchase_gtins: ["061414155557"],
      deposited: 1,
      providers: ["spectivlabs.thecouponbureau.org"],
      rolling_expiration: 1,
      rolling_expiration_days: 1,
      settled: 1,
      finalized: 0,
      lookupcodes: [],
      allowed_retailers: [],
      settlement_email_sent: 1,
      timezone_val: "Pacific/Honolulu",
      create_date: "2023-03-16",
      internal_id: "46a62653",
      approve_date: "2023-03-16",
      offer_code: "444444",
      base_gs1: "811200497900444444",
      email_domain: "spectivlabs.thecouponbureau.org",
      created_by_email_domain: "spectivlabs.thecouponbureau.org",
      brand_id: "a68f20bd",
      description: "test desc",
      campaign_start_time: "2023-03-15",
      campaign_end_time: "2023-03-31",
      redemption_start_time: "2023-03-15",
      redemption_end_time: "2023-03-31",
      total_circulation: 1000,
      primary_purchase_save_value: 1,
      primary_purchase_requirements: 1,
      primary_purchase_req_code: 1,
      executionId: "fc5a51a0-cec6-4041-8f27-50597cf634d3",
      executedByEmail: "148a7d730f1dd0a875aa09f39587c001@spectivlabs.thecouponbureau.org",
      update_datetime: 1678949079468,
      campaign_metadata: {
        allow_override: false,
        title: "test Radinasys",
        description: "test",
        terms: "https://thecouponbureau.org/terms",
        mobile_image_url: "https://gitsy-product-images.s3.amazonaws.com/gitsy_seltzer.png",
        desktop_image_url: "https://gitsy-product-images.s3.amazonaws.com/gitsy_seltzer.png",
        dollar_amount: 10,
      },
      settled_datetime: "2023-04-09",
      manufacturer: "spectiv labs",
      brand_name: "RadinasysTest",
      provider_text: "spectiv labs",
      status: {
        expired: 1,
      },
      access_type: "full_set_with_lock",
      link: "https://gitsyv2app.page.link/L2nj6ndw3nkFhBwD8",
    },
    {
      primary_purchase_gtins: ["061414155557"],
      deposited: 108,
      providers: ["spectivlabs.thecouponbureau.org"],
      settled: 1,
      finalized: 0,
      lookupcodes: [],
      allowed_retailers: [],
      settlement_email_sent: 1,
      create_date: "2023-02-23",
      internal_id: "056e72e3",
      approve_date: "2023-02-23",
      offer_code: "041383",
      base_gs1: "811200497900041383",
      email_domain: "spectivlabs.thecouponbureau.org",
      created_by_email_domain: "spectivlabs.thecouponbureau.org",
      brand_id: "12648298",
      description: "Gitsy Cola",
      campaign_start_time: "2023-02-22",
      campaign_end_time: "2023-05-22",
      redemption_start_time: "2023-02-22",
      redemption_end_time: "2023-05-22",
      total_circulation: 10000,
      primary_purchase_save_value: 300,
      primary_purchase_requirements: 1,
      primary_purchase_req_code: 0,
      executionId: "48f52b4b-c481-4ff4-8acd-556337d1515d",
      executedByEmail: "148a7d730f1dd0a875aa09f39587c001@spectivlabs.thecouponbureau.org",
      update_datetime: 1678887721332,
      campaign_metadata: {
        allow_override: false,
        title: "Save $3",
        description: "GITSY COLA 6-PACK: save on any flavored Gitsy cola 6-pack",
        terms: "https://thecouponbureau.org/terms",
        mobile_image_url: "https://gitsy-product-images.s3.amazonaws.com/gitsy_cola.png",
        desktop_image_url: "https://gitsy-product-images.s3.amazonaws.com/gitsy_cola.png",
        dollar_amount: 3,
      },
      settled_datetime: "2023-05-31",
      manufacturer: "spectiv labs",
      brand_name: "Gitsy_327593",
      provider_text: "spectiv labs",
      timezone_val: "Pacific/Honolulu",
      status: {
        expired: 1,
      },
      access_type: "full_set_with_lock",
      link: "https://gitsyv2app.page.link/QKydRmdQZmzepaa89",
    },
    {
      primary_purchase_gtins: ["1"],
      deposited: 172,
      providers: ["spectivlabs.thecouponbureau.org"],
      rolling_expiration: 1,
      rolling_expiration_days: 30,
      settled: 0,
      finalized: 0,
      lookupcodes: [],
      allowed_retailers: [],
      settlement_email_sent: 0,
      create_date: "2023-02-02",
      internal_id: "e44199ce",
      approve_date: "2023-02-01",
      offer_code: "821902",
      base_gs1: "811200497900821902",
      email_domain: "spectivlabs.thecouponbureau.org",
      created_by_email_domain: "spectivlabs.thecouponbureau.org",
      brand_id: "12648298",
      description: "Gitsy Desc",
      campaign_start_time: "2023-02-01",
      campaign_end_time: "2024-02-02",
      redemption_start_time: "2023-02-01",
      redemption_end_time: "2024-02-02",
      total_circulation: 1000000,
      primary_purchase_save_value: 1,
      primary_purchase_requirements: 1,
      primary_purchase_req_code: 1,
      additional_purchase_rules_code: 1,
      second_purchase_requirements: 1,
      second_purchase_gs1_company_prefix: 1,
      second_purchase_req_code: 1,
      third_purchase_requirements: 1,
      third_purchase_gs1_company_prefix: 1,
      third_purchase_req_code: 1,
      save_value_code: 1,
      applies_to_which_item: 1,
      donot_multiply_flag: 1,
      executionId: "48ffdd91-e5d1-45c2-9f9c-6dd2c813f4b7",
      executedByEmail: "148a7d730f1dd0a875aa09f39587c001@spectivlabs.thecouponbureau.org",
      update_datetime: 1676377543663,
      campaign_metadata: {
        allow_override: false,
        title: "SAVE $15.00",
        description: "LYSOL® on Any TWO (2) Lysol® Products (excluding trial and travel sizes)",
        terms: "https://thecouponbureau.org/terms",
        mobile_image_url:
          "https://cdn.cpnscdn.com/static.coupons.com/ext/bussys/cpa/pod/62/211/2862211_bc09c6aa-55c0-4788-ad78-33975b04e086_2x.jpg",
        desktop_image_url:
          "https://cdn.cpnscdn.com/static.coupons.com/ext/bussys/cpa/pod/62/211/2862211_bc09c6aa-55c0-4788-ad78-33975b04e086_2x.jpg",
        dollar_amount: 15,
      },
      manufacturer: "spectiv labs",
      brand_name: "Gitsy_327593",
      provider_text: "spectiv labs",
      timezone_val: "Pacific/Honolulu",
      status: {
        locked: 1,
      },
      access_type: "full_set_with_lock",
      link: "https://gitsyv2app.page.link/BEQTSpdhscLUs6LEA",
    },
    {
      primary_purchase_gtins: ["1"],
      deposited: 20,
      providers: ["spectivlabs.thecouponbureau.org"],
      rolling_expiration: 1,
      rolling_expiration_days: 30,
      settled: 0,
      finalized: 0,
      lookupcodes: [],
      allowed_retailers: [],
      settlement_email_sent: 0,
      create_date: "2023-02-02",
      internal_id: "0a10816c",
      approve_date: "2023-02-01",
      offer_code: "246726",
      base_gs1: "811200497900246726",
      email_domain: "spectivlabs.thecouponbureau.org",
      created_by_email_domain: "spectivlabs.thecouponbureau.org",
      brand_id: "12648298",
      description: "Gitsy Desc",
      campaign_start_time: "2023-02-01",
      campaign_end_time: "2024-02-02",
      redemption_start_time: "2023-02-01",
      redemption_end_time: "2024-02-02",
      total_circulation: 1000000,
      primary_purchase_save_value: 1,
      primary_purchase_requirements: 1,
      primary_purchase_req_code: 1,
      additional_purchase_rules_code: 1,
      second_purchase_requirements: 1,
      second_purchase_gs1_company_prefix: 1,
      second_purchase_req_code: 1,
      third_purchase_requirements: 1,
      third_purchase_gs1_company_prefix: 1,
      third_purchase_req_code: 1,
      save_value_code: 1,
      applies_to_which_item: 1,
      donot_multiply_flag: 1,
      executionId: "f3f37356-0832-4ed0-a2b4-bb21763679f8",
      executedByEmail: "148a7d730f1dd0a875aa09f39587c001@spectivlabs.thecouponbureau.org",
      update_datetime: 1675338422522,
      campaign_metadata: {
        allow_override: false,
        title: "SAVE $1.00",
        description: "LYSOL® on Any TWO (2) Lysol® Products (excluding trial and travel sizes)",
        terms: "https://thecouponbureau.org/terms",
        mobile_image_url:
          "https://cdn.cpnscdn.com/static.coupons.com/ext/bussys/cpa/pod/62/211/2862211_bc09c6aa-55c0-4788-ad78-33975b04e086_2x.jpg",
        desktop_image_url:
          "https://cdn.cpnscdn.com/static.coupons.com/ext/bussys/cpa/pod/62/211/2862211_bc09c6aa-55c0-4788-ad78-33975b04e086_2x.jpg",
        dollar_amount: 10,
      },
      manufacturer: "spectiv labs",
      brand_name: "Gitsy_327593",
      provider_text: "spectiv labs",
      timezone_val: "Pacific/Honolulu",
      status: {
        locked: 1,
      },
      access_type: "full_set_with_lock",
      link: "https://gitsyv2app.page.link/RPkquzFYvbQt9WEN9",
    },
    {
      primary_purchase_gtins: ["1"],
      deposited: 4,
      providers: ["spectivlabs.thecouponbureau.org"],
      rolling_expiration: 1,
      rolling_expiration_days: 30,
      settled: 0,
      finalized: 0,
      lookupcodes: [],
      allowed_retailers: [],
      settlement_email_sent: 0,
      create_date: "2023-02-02",
      internal_id: "3c65efdb",
      approve_date: "2023-02-01",
      offer_code: "695146",
      base_gs1: "811200497900695146",
      email_domain: "spectivlabs.thecouponbureau.org",
      created_by_email_domain: "spectivlabs.thecouponbureau.org",
      brand_id: "12648298",
      description: "Gitsy Desc",
      campaign_start_time: "2023-02-01",
      campaign_end_time: "2024-02-02",
      redemption_start_time: "2023-02-01",
      redemption_end_time: "2024-02-02",
      total_circulation: 1000000,
      primary_purchase_save_value: 1,
      primary_purchase_requirements: 1,
      primary_purchase_req_code: 1,
      additional_purchase_rules_code: 1,
      second_purchase_requirements: 1,
      second_purchase_gs1_company_prefix: 1,
      second_purchase_req_code: 1,
      third_purchase_requirements: 1,
      third_purchase_gs1_company_prefix: 1,
      third_purchase_req_code: 1,
      save_value_code: 1,
      applies_to_which_item: 1,
      donot_multiply_flag: 1,
      executionId: "49faafba-f458-4ba8-817f-6c9c9d081820",
      executedByEmail: "148a7d730f1dd0a875aa09f39587c001@spectivlabs.thecouponbureau.org",
      update_datetime: 1675338418776,
      campaign_metadata: {
        allow_override: false,
        title: "SAVE $1.00",
        description: "LYSOL® on Any TWO (2) Lysol® Products (excluding trial and travel sizes)",
        terms: "https://thecouponbureau.org/terms",
        mobile_image_url:
          "https://cdn.cpnscdn.com/static.coupons.com/ext/bussys/cpa/pod/62/211/2862211_bc09c6aa-55c0-4788-ad78-33975b04e086_2x.jpg",
        desktop_image_url:
          "https://cdn.cpnscdn.com/static.coupons.com/ext/bussys/cpa/pod/62/211/2862211_bc09c6aa-55c0-4788-ad78-33975b04e086_2x.jpg",
        dollar_amount: 10,
      },
      manufacturer: "spectiv labs",
      brand_name: "Gitsy_327593",
      provider_text: "spectiv labs",
      timezone_val: "Pacific/Honolulu",
      status: {
        locked: 1,
      },
      access_type: "full_set_with_lock",
      link: "https://gitsyv2app.page.link/DMe3HHqmvv9UR8F99",
    },
    {
      primary_purchase_gtins: ["1"],
      deposited: 4,
      providers: ["spectivlabs.thecouponbureau.org"],
      rolling_expiration: 1,
      rolling_expiration_days: 30,
      settled: 0,
      finalized: 0,
      lookupcodes: [],
      allowed_retailers: [],
      settlement_email_sent: 0,
      create_date: "2023-02-02",
      internal_id: "073d122b",
      approve_date: "2023-02-01",
      offer_code: "147952",
      base_gs1: "811200497900147952",
      email_domain: "spectivlabs.thecouponbureau.org",
      created_by_email_domain: "spectivlabs.thecouponbureau.org",
      brand_id: "12648298",
      description: "Gitsy Desc",
      campaign_start_time: "2023-02-01",
      campaign_end_time: "2024-02-02",
      redemption_start_time: "2023-02-01",
      redemption_end_time: "2024-02-02",
      total_circulation: 1000000,
      primary_purchase_save_value: 1,
      primary_purchase_requirements: 1,
      primary_purchase_req_code: 1,
      additional_purchase_rules_code: 1,
      second_purchase_requirements: 1,
      second_purchase_gs1_company_prefix: 1,
      second_purchase_req_code: 1,
      third_purchase_requirements: 1,
      third_purchase_gs1_company_prefix: 1,
      third_purchase_req_code: 1,
      save_value_code: 1,
      applies_to_which_item: 1,
      donot_multiply_flag: 1,
      executionId: "43a38871-8923-4013-88fa-ea035ac9e6df",
      executedByEmail: "148a7d730f1dd0a875aa09f39587c001@spectivlabs.thecouponbureau.org",
      update_datetime: 1675338413999,
      campaign_metadata: {
        allow_override: false,
        title: "SAVE $1.00",
        description: "LYSOL® on Any TWO (2) Lysol® Products (excluding trial and travel sizes)",
        terms: "https://thecouponbureau.org/terms",
        mobile_image_url:
          "https://cdn.cpnscdn.com/static.coupons.com/ext/bussys/cpa/pod/62/211/2862211_bc09c6aa-55c0-4788-ad78-33975b04e086_2x.jpg",
        desktop_image_url:
          "https://cdn.cpnscdn.com/static.coupons.com/ext/bussys/cpa/pod/62/211/2862211_bc09c6aa-55c0-4788-ad78-33975b04e086_2x.jpg",
        dollar_amount: 10,
      },
      manufacturer: "spectiv labs",
      brand_name: "Gitsy_327593",
      provider_text: "spectiv labs",
      timezone_val: "Pacific/Honolulu",
      status: {
        locked: 1,
      },
      access_type: "full_set_with_lock",
      link: "https://gitsyv2app.page.link/di2i7oWM6nZtob8M9",
    },
    {
      primary_purchase_gtins: ["1"],
      deposited: 4,
      providers: ["spectivlabs.thecouponbureau.org"],
      rolling_expiration: 1,
      rolling_expiration_days: 30,
      settled: 0,
      finalized: 0,
      lookupcodes: [],
      allowed_retailers: [],
      settlement_email_sent: 0,
      create_date: "2023-02-02",
      internal_id: "25dd0cc1",
      approve_date: "2023-02-01",
      offer_code: "647709",
      base_gs1: "811200497900647709",
      email_domain: "spectivlabs.thecouponbureau.org",
      created_by_email_domain: "spectivlabs.thecouponbureau.org",
      brand_id: "12648298",
      description: "Gitsy Desc",
      campaign_start_time: "2023-02-01",
      campaign_end_time: "2024-02-02",
      redemption_start_time: "2023-02-01",
      redemption_end_time: "2024-02-02",
      total_circulation: 1000000,
      primary_purchase_save_value: 1,
      primary_purchase_requirements: 1,
      primary_purchase_req_code: 1,
      additional_purchase_rules_code: 1,
      second_purchase_requirements: 1,
      second_purchase_gs1_company_prefix: 1,
      second_purchase_req_code: 1,
      third_purchase_requirements: 1,
      third_purchase_gs1_company_prefix: 1,
      third_purchase_req_code: 1,
      save_value_code: 1,
      applies_to_which_item: 1,
      donot_multiply_flag: 1,
      executionId: "bbfea74c-0b4b-46a5-8477-bed6e2fc38fe",
      executedByEmail: "148a7d730f1dd0a875aa09f39587c001@spectivlabs.thecouponbureau.org",
      update_datetime: 1675338403938,
      campaign_metadata: {
        allow_override: false,
        title: "SAVE $1.00",
        description: "LYSOL® on Any TWO (2) Lysol® Products (excluding trial and travel sizes)",
        terms: "https://thecouponbureau.org/terms",
        mobile_image_url:
          "https://cdn.cpnscdn.com/static.coupons.com/ext/bussys/cpa/pod/62/211/2862211_bc09c6aa-55c0-4788-ad78-33975b04e086_2x.jpg",
        desktop_image_url:
          "https://cdn.cpnscdn.com/static.coupons.com/ext/bussys/cpa/pod/62/211/2862211_bc09c6aa-55c0-4788-ad78-33975b04e086_2x.jpg",
        dollar_amount: 10,
      },
      manufacturer: "spectiv labs",
      brand_name: "Gitsy_327593",
      provider_text: "spectiv labs",
      timezone_val: "Pacific/Honolulu",
      status: {
        locked: 1,
      },
      access_type: "full_set_with_lock",
      link: "https://gitsyv2app.page.link/2pssZkMBxsgz5pLC7",
    },
    {
      primary_purchase_gtins: ["1"],
      deposited: 4,
      providers: ["spectivlabs.thecouponbureau.org"],
      rolling_expiration: 1,
      rolling_expiration_days: 30,
      settled: 0,
      finalized: 0,
      lookupcodes: [],
      allowed_retailers: [],
      settlement_email_sent: 0,
      create_date: "2023-02-02",
      internal_id: "cde72c59",
      approve_date: "2023-02-01",
      offer_code: "887621",
      base_gs1: "811200497900887621",
      email_domain: "spectivlabs.thecouponbureau.org",
      created_by_email_domain: "spectivlabs.thecouponbureau.org",
      brand_id: "12648298",
      description: "Gitsy Desc",
      campaign_start_time: "2023-02-01",
      campaign_end_time: "2024-02-02",
      redemption_start_time: "2023-02-01",
      redemption_end_time: "2024-02-02",
      total_circulation: 1000000,
      primary_purchase_save_value: 1,
      primary_purchase_requirements: 1,
      primary_purchase_req_code: 1,
      additional_purchase_rules_code: 1,
      second_purchase_requirements: 1,
      second_purchase_gs1_company_prefix: 1,
      second_purchase_req_code: 1,
      third_purchase_requirements: 1,
      third_purchase_gs1_company_prefix: 1,
      third_purchase_req_code: 1,
      save_value_code: 1,
      applies_to_which_item: 1,
      donot_multiply_flag: 1,
      executionId: "744ed09f-7505-49d7-8132-f3045ea01d2c",
      executedByEmail: "148a7d730f1dd0a875aa09f39587c001@spectivlabs.thecouponbureau.org",
      update_datetime: 1675338397359,
      campaign_metadata: {
        allow_override: false,
        title: "SAVE $1.00",
        description: "LYSOL® on Any TWO (2) Lysol® Products (excluding trial and travel sizes)",
        terms: "https://thecouponbureau.org/terms",
        mobile_image_url:
          "https://cdn.cpnscdn.com/static.coupons.com/ext/bussys/cpa/pod/62/211/2862211_bc09c6aa-55c0-4788-ad78-33975b04e086_2x.jpg",
        desktop_image_url:
          "https://cdn.cpnscdn.com/static.coupons.com/ext/bussys/cpa/pod/62/211/2862211_bc09c6aa-55c0-4788-ad78-33975b04e086_2x.jpg",
        dollar_amount: 10,
      },
      manufacturer: "spectiv labs",
      brand_name: "Gitsy_327593",
      provider_text: "spectiv labs",
      timezone_val: "Pacific/Honolulu",
      status: {
        locked: 1,
      },
      access_type: "full_set_with_lock",
      link: "https://gitsyv2app.page.link/LLWSnBRC3vP8Uu1z9",
    },
    {
      primary_purchase_gtins: ["1"],
      deposited: 12,
      providers: ["spectivlabs.thecouponbureau.org"],
      rolling_expiration: 1,
      rolling_expiration_days: 30,
      settled: 0,
      finalized: 0,
      lookupcodes: [],
      allowed_retailers: [],
      settlement_email_sent: 0,
      create_date: "2023-02-02",
      internal_id: "19b49875",
      approve_date: "2023-02-01",
      offer_code: "575296",
      base_gs1: "811200497900575296",
      email_domain: "spectivlabs.thecouponbureau.org",
      created_by_email_domain: "spectivlabs.thecouponbureau.org",
      brand_id: "12648298",
      description: "Gitsy Desc",
      campaign_start_time: "2023-02-01",
      campaign_end_time: "2024-02-02",
      redemption_start_time: "2023-02-01",
      redemption_end_time: "2024-02-02",
      total_circulation: 1000000,
      primary_purchase_save_value: 1,
      primary_purchase_requirements: 1,
      primary_purchase_req_code: 1,
      additional_purchase_rules_code: 1,
      second_purchase_requirements: 1,
      second_purchase_gs1_company_prefix: 1,
      second_purchase_req_code: 1,
      third_purchase_requirements: 1,
      third_purchase_gs1_company_prefix: 1,
      third_purchase_req_code: 1,
      save_value_code: 1,
      applies_to_which_item: 1,
      donot_multiply_flag: 1,
      executionId: "f12d3547-6536-4112-9afb-ec14b23178f7",
      executedByEmail: "148a7d730f1dd0a875aa09f39587c001@spectivlabs.thecouponbureau.org",
      update_datetime: 1675338377573,
      campaign_metadata: {
        allow_override: false,
        title: "SAVE $1.00",
        description: "LYSOL® on Any TWO (2) Lysol® Products (excluding trial and travel sizes)",
        terms: "https://thecouponbureau.org/terms",
        mobile_image_url:
          "https://cdn.cpnscdn.com/static.coupons.com/ext/bussys/cpa/pod/62/211/2862211_bc09c6aa-55c0-4788-ad78-33975b04e086_2x.jpg",
        desktop_image_url:
          "https://cdn.cpnscdn.com/static.coupons.com/ext/bussys/cpa/pod/62/211/2862211_bc09c6aa-55c0-4788-ad78-33975b04e086_2x.jpg",
        dollar_amount: 10,
      },
      manufacturer: "spectiv labs",
      brand_name: "Gitsy_327593",
      provider_text: "spectiv labs",
      timezone_val: "Pacific/Honolulu",
      status: {
        locked: 1,
      },
      access_type: "full_set_with_lock",
      link: "https://gitsyv2app.page.link/moWfnnbKhFKTsXFg7",
    },
    {
      primary_purchase_gtins: ["1"],
      deposited: 4,
      providers: ["spectivlabs.thecouponbureau.org"],
      rolling_expiration: 1,
      rolling_expiration_days: 30,
      settled: 0,
      finalized: 0,
      lookupcodes: [],
      allowed_retailers: [],
      settlement_email_sent: 0,
      create_date: "2023-02-02",
      internal_id: "9b6f7024",
      approve_date: "2023-02-01",
      offer_code: "410321",
      base_gs1: "811200497900410321",
      email_domain: "spectivlabs.thecouponbureau.org",
      created_by_email_domain: "spectivlabs.thecouponbureau.org",
      brand_id: "12648298",
      description: "Gitsy Desc",
      campaign_start_time: "2023-02-01",
      campaign_end_time: "2024-02-02",
      redemption_start_time: "2023-02-01",
      redemption_end_time: "2024-02-02",
      total_circulation: 1000000,
      primary_purchase_save_value: 1,
      primary_purchase_requirements: 1,
      primary_purchase_req_code: 1,
      additional_purchase_rules_code: 1,
      second_purchase_requirements: 1,
      second_purchase_gs1_company_prefix: 1,
      second_purchase_req_code: 1,
      third_purchase_requirements: 1,
      third_purchase_gs1_company_prefix: 1,
      third_purchase_req_code: 1,
      save_value_code: 1,
      applies_to_which_item: 1,
      donot_multiply_flag: 1,
      executionId: "e90496b9-ae78-4c83-a7a8-27dc5c262481",
      executedByEmail: "148a7d730f1dd0a875aa09f39587c001@spectivlabs.thecouponbureau.org",
      update_datetime: 1675338366325,
      campaign_metadata: {
        allow_override: false,
        title: "SAVE $1.00",
        description: "LYSOL® on Any TWO (2) Lysol® Products (excluding trial and travel sizes)",
        terms: "https://thecouponbureau.org/terms",
        mobile_image_url:
          "https://cdn.cpnscdn.com/static.coupons.com/ext/bussys/cpa/pod/62/211/2862211_bc09c6aa-55c0-4788-ad78-33975b04e086_2x.jpg",
        desktop_image_url:
          "https://cdn.cpnscdn.com/static.coupons.com/ext/bussys/cpa/pod/62/211/2862211_bc09c6aa-55c0-4788-ad78-33975b04e086_2x.jpg",
        dollar_amount: 10,
      },
      manufacturer: "spectiv labs",
      brand_name: "Gitsy_327593",
      provider_text: "spectiv labs",
      timezone_val: "Pacific/Honolulu",
      status: {
        locked: 1,
      },
      access_type: "full_set_with_lock",
      link: "https://gitsyv2app.page.link/WCkkTLBYHvXUJ4378",
    },
    {
      primary_purchase_gtins: ["1"],
      deposited: 5,
      providers: ["spectivlabs.thecouponbureau.org"],
      rolling_expiration: 1,
      rolling_expiration_days: 30,
      settled: 0,
      finalized: 0,
      lookupcodes: [],
      allowed_retailers: [],
      settlement_email_sent: 0,
      create_date: "2023-02-02",
      internal_id: "7046c048",
      approve_date: "2023-02-01",
      offer_code: "380806",
      base_gs1: "811200497900380806",
      email_domain: "spectivlabs.thecouponbureau.org",
      created_by_email_domain: "spectivlabs.thecouponbureau.org",
      brand_id: "12648298",
      description: "Gitsy Desc",
      campaign_start_time: "2023-02-01",
      campaign_end_time: "2024-02-02",
      redemption_start_time: "2023-02-01",
      redemption_end_time: "2024-02-02",
      total_circulation: 1000000,
      primary_purchase_save_value: 1,
      primary_purchase_requirements: 1,
      primary_purchase_req_code: 1,
      additional_purchase_rules_code: 1,
      second_purchase_requirements: 1,
      second_purchase_gs1_company_prefix: 1,
      second_purchase_req_code: 1,
      third_purchase_requirements: 1,
      third_purchase_gs1_company_prefix: 1,
      third_purchase_req_code: 1,
      save_value_code: 1,
      applies_to_which_item: 1,
      donot_multiply_flag: 1,
      executionId: "7ab188fc-37fd-46ec-a9f1-aca7d17fc57c",
      executedByEmail: "148a7d730f1dd0a875aa09f39587c001@spectivlabs.thecouponbureau.org",
      update_datetime: 1675338359334,
      campaign_metadata: {
        allow_override: false,
        title: "SAVE $1.00",
        description: "LYSOL® on Any TWO (2) Lysol® Products (excluding trial and travel sizes)",
        terms: "https://thecouponbureau.org/terms",
        mobile_image_url:
          "https://cdn.cpnscdn.com/static.coupons.com/ext/bussys/cpa/pod/62/211/2862211_bc09c6aa-55c0-4788-ad78-33975b04e086_2x.jpg",
        desktop_image_url:
          "https://cdn.cpnscdn.com/static.coupons.com/ext/bussys/cpa/pod/62/211/2862211_bc09c6aa-55c0-4788-ad78-33975b04e086_2x.jpg",
        dollar_amount: 10,
      },
      manufacturer: "spectiv labs",
      brand_name: "Gitsy_327593",
      provider_text: "spectiv labs",
      timezone_val: "Pacific/Honolulu",
      status: {
        locked: 1,
      },
      access_type: "full_set_with_lock",
      link: "https://gitsyv2app.page.link/wsXLea2Gpmi8hWoJA",
    },
    {
      primary_purchase_gtins: ["1"],
      deposited: 5,
      providers: ["spectivlabs.thecouponbureau.org"],
      rolling_expiration: 1,
      rolling_expiration_days: 30,
      settled: 0,
      finalized: 0,
      lookupcodes: [],
      allowed_retailers: [],
      settlement_email_sent: 0,
      create_date: "2023-02-02",
      internal_id: "316b2561",
      approve_date: "2023-02-01",
      offer_code: "045248",
      base_gs1: "811200497900045248",
      email_domain: "spectivlabs.thecouponbureau.org",
      created_by_email_domain: "spectivlabs.thecouponbureau.org",
      brand_id: "12648298",
      description: "Gitsy Desc",
      campaign_start_time: "2023-02-01",
      campaign_end_time: "2024-02-02",
      redemption_start_time: "2023-02-01",
      redemption_end_time: "2024-02-02",
      total_circulation: 1000000,
      primary_purchase_save_value: 1,
      primary_purchase_requirements: 1,
      primary_purchase_req_code: 1,
      additional_purchase_rules_code: 1,
      second_purchase_requirements: 1,
      second_purchase_gs1_company_prefix: 1,
      second_purchase_req_code: 1,
      third_purchase_requirements: 1,
      third_purchase_gs1_company_prefix: 1,
      third_purchase_req_code: 1,
      save_value_code: 1,
      applies_to_which_item: 1,
      donot_multiply_flag: 1,
      executionId: "7f2f9cb0-901f-41e1-bfb5-8d9fa6befea6",
      executedByEmail: "148a7d730f1dd0a875aa09f39587c001@spectivlabs.thecouponbureau.org",
      update_datetime: 1675338348030,
      campaign_metadata: {
        allow_override: false,
        title: "SAVE $1.00",
        description: "LYSOL® on Any TWO (2) Lysol® Products (excluding trial and travel sizes)",
        terms: "https://thecouponbureau.org/terms",
        mobile_image_url:
          "https://cdn.cpnscdn.com/static.coupons.com/ext/bussys/cpa/pod/62/211/2862211_bc09c6aa-55c0-4788-ad78-33975b04e086_2x.jpg",
        desktop_image_url:
          "https://cdn.cpnscdn.com/static.coupons.com/ext/bussys/cpa/pod/62/211/2862211_bc09c6aa-55c0-4788-ad78-33975b04e086_2x.jpg",
        dollar_amount: 10,
      },
      manufacturer: "spectiv labs",
      brand_name: "Gitsy_327593",
      provider_text: "spectiv labs",
      timezone_val: "Pacific/Honolulu",
      status: {
        locked: 1,
      },
      access_type: "full_set_with_lock",
      link: "https://gitsyv2app.page.link/CxNzkw3hHXYQt5b67",
    },
  ],
  galleries: {
    galleries: [
      {
        base_gs1s: [
          {
            base_gs1: "811200497900821902",
            is_included_in_gallery: false,
          },
          {
            base_gs1: "811200497900246726",
            is_included_in_gallery: false,
          },
          {
            base_gs1: "811200497900695146",
            is_included_in_gallery: false,
          },
          {
            base_gs1: "811200497900147952",
            is_included_in_gallery: false,
          },
          {
            base_gs1: "811200497900647709",
            is_included_in_gallery: false,
          },
          {
            base_gs1: "811200497900887621",
            is_included_in_gallery: false,
          },
          {
            base_gs1: "811200497900575296",
            is_included_in_gallery: false,
          },
          {
            base_gs1: "811200497900410321",
            is_included_in_gallery: false,
          },
          {
            base_gs1: "811200497900380806",
            is_included_in_gallery: false,
          },
          {
            base_gs1: "811200497900045248",
            is_included_in_gallery: false,
          },
        ],
        image_path:
          "https://gitsy-b2b-dev.s3.ap-south-1.amazonaws.com/01H6R1GGWD5HE1SSX4TKVYA106/gallery_image/1697021809392.depositphotos_256778368-stock-illustration-vector-cartoon-slush-icon-isolated.jpg",
        enterprise_id: "01H6R1GGWD5HE1SSX4TKVYA106",
        link: "https://gitsyv2app.page.link/JTbhHdgzrXSnJXpr5",
        description: null,
        id: "01HCF63NXW0HYY0TT927PECCJS",
        name: "LYSOL Gallery",
      },
      {
        base_gs1s: [
          {
            base_gs1: "811200497900011149",
            is_included_in_gallery: false,
          },
          {
            base_gs1: "811200497900012018",
            is_included_in_gallery: false,
          },
          {
            base_gs1: "811200497900031120",
            is_included_in_gallery: false,
          },
          {
            base_gs1: "811200497900010452",
            is_included_in_gallery: false,
          },
          {
            base_gs1: "811200497900033186",
            is_included_in_gallery: false,
          },
          {
            base_gs1: "811200497900111798",
            is_included_in_gallery: false,
          },
          {
            base_gs1: "811200497900122282",
            is_included_in_gallery: false,
          },
        ],
        image_path:
          "https://gitsy-b2b-dev.s3.ap-south-1.amazonaws.com/01H6R1GGWD5HE1SSX4TKVYA106/gallery_image/1697021879885.favicon-96x96.png",
        enterprise_id: "01H6R1GGWD5HE1SSX4TKVYA106",
        link: "https://gitsyv2app.page.link/PVk66ueYBoDR1RkP7",
        description: null,
        id: "01HCF65TBWYS540Z660RF5ZMZT",
        name: "Gitsy Gallery",
      },
      {
        base_gs1s: [
          {
            lookupcodes: [],
            status: {
              locked: 1,
            },
            email_domain: "spectivlabs.thecouponbureau.org",
            store_coupon: 0,
            max_quantity_to_group: "1",
            primary_purchase_req_code: 0,
            save_value_code: 0,
            brand_id: "3de239b9",
            primary_purchase_requirements: 2,
            internal_id: "ab7abff0",
            settled: 0,
            is_included_in_gallery: true,
            settlement_email_sent: 0,
            primary_purchase_save_value: 299,
            created_at: "2023-09-29T11:27:24.040Z",
            finalized: 0,
            executionId: "7fb32297-13b7-4465-a9c8-9a32b558e929",
            allowed_retailers: [],
            free_quantity_type: "",
            offer_code: "597921",
            redemption_end_time: "2023-10-13",
            link: "https://gitsyv2app.page.link/3ASPVke8vazLHiEFA",
            access_type: "full_set_with_lock",
            description:
              "Get $2.99 off on minimum shopping of 2 units (Amul Pasteurised Butter) at your nearest store till 7th October 2023",
            campaign_metadata: {
              mobile_image_url:
                "https://gitsy-b2b-dev.s3.ap-south-1.amazonaws.com/01H6R1GGWD5HE1SSX4TKVYA106/product_image/1694519849926.95d868ed-6acd-4efc-990f-ee892ff3118d.__CR0%2C0%2C970%2C600_PT0_SX970_V1___.jpg",
              dollar_amount: 2.99,
              terms: "https://thecouponbureau.org/terms",
              desktop_image_url:
                "https://gitsy-b2b-dev.s3.ap-south-1.amazonaws.com/01H6R1GGWD5HE1SSX4TKVYA106/product_image/1694519849926.95d868ed-6acd-4efc-990f-ee892ff3118d.__CR0%2C0%2C970%2C600_PT0_SX970_V1___.jpg",
              allow_override: false,
              description:
                "Get $2.99 off on minimum shopping of 2 units (Amul Pasteurised Butter) at your nearest store till 7th October 2023",
              title: "Get $2.99 off",
            },
            rolling_expiration: 1,
            executedByEmail: "gitsyb2bapikeys_try@spectivlabs.thecouponbureau.org",
            brand_name: "Amul",
            total_circulation: 1000,
            campaign_start_time: "2023-09-29",
            create_date: "2023-09-29",
            campaign_end_time: "2023-10-07",
            donot_multiply_flag: 1,
            rolling_expiration_days: 7,
            max_limit_to_avail_offer: "",
            deposited: 0,
            update_datetime: 1695986842362,
            redemption_start_time: "2023-10-05",
            created_by_email_domain: "spectivlabs.thecouponbureau.org",
            approve_date: "2023-09-29",
            primary_purchase_eans: ["8901262010016"],
            providers: ["spectivlabs.thecouponbureau.org", "radiansys.thecouponbureau.org"],
            enterprise_id: "01H6R1GGWD5HE1SSX4TKVYA106",
            manufacturer: "spectiv labs",
            timezone_val: "Pacific/Honolulu",
            base_gs1: "811200497900597921",
            primary_purchase_gtins: [],
            provider_text: "",
          },
          {
            lookupcodes: [],
            status: {
              locked: 1,
            },
            email_domain: "spectivlabs.thecouponbureau.org",
            store_coupon: 0,
            max_quantity_to_group: "1",
            primary_purchase_req_code: 0,
            save_value_code: 0,
            brand_id: "3de239b9",
            primary_purchase_requirements: 3,
            internal_id: "d09edd52",
            settled: 0,
            is_included_in_gallery: true,
            settlement_email_sent: 0,
            primary_purchase_save_value: 399,
            created_at: "2023-09-29T11:30:20.717Z",
            finalized: 0,
            executionId: "84973ea3-98c7-4e0a-9fae-7047ee255370",
            allowed_retailers: [],
            free_quantity_type: "",
            offer_code: "046491",
            redemption_end_time: "2023-10-14",
            link: "https://gitsyv2app.page.link/BQiZnhqjKueH21GP7",
            access_type: "full_set_with_lock",
            description:
              "Save $3.99 on minimum shopping of 3 units (Amul Pasteurised Butter) at your nearest store till 12th October 2023",
            campaign_metadata: {
              mobile_image_url:
                "https://gitsy-b2b-dev.s3.ap-south-1.amazonaws.com/01H6R1GGWD5HE1SSX4TKVYA106/product_image/1694519849926.95d868ed-6acd-4efc-990f-ee892ff3118d.__CR0%2C0%2C970%2C600_PT0_SX970_V1___.jpg",
              dollar_amount: 3.99,
              terms: "https://thecouponbureau.org/terms",
              desktop_image_url:
                "https://gitsy-b2b-dev.s3.ap-south-1.amazonaws.com/01H6R1GGWD5HE1SSX4TKVYA106/product_image/1694519849926.95d868ed-6acd-4efc-990f-ee892ff3118d.__CR0%2C0%2C970%2C600_PT0_SX970_V1___.jpg",
              allow_override: false,
              description:
                "Save $3.99 on minimum shopping of 3 units (Amul Pasteurised Butter) at your nearest store till 12th October 2023",
              title: "Save $3.99 ",
            },
            rolling_expiration: 1,
            executedByEmail: "gitsyb2bapikeys_try@spectivlabs.thecouponbureau.org",
            brand_name: "Amul",
            total_circulation: 1000,
            campaign_start_time: "2023-09-29",
            create_date: "2023-09-29",
            campaign_end_time: "2023-10-07",
            donot_multiply_flag: 1,
            rolling_expiration_days: 7,
            max_limit_to_avail_offer: "",
            deposited: 0,
            update_datetime: 1695987019003,
            redemption_start_time: "2023-10-06",
            created_by_email_domain: "spectivlabs.thecouponbureau.org",
            approve_date: "2023-09-29",
            primary_purchase_eans: ["8901262010016"],
            providers: ["radiansys.thecouponbureau.org", "spectivlabs.thecouponbureau.org"],
            enterprise_id: "01H6R1GGWD5HE1SSX4TKVYA106",
            manufacturer: "spectiv labs",
            timezone_val: "Pacific/Honolulu",
            base_gs1: "811200497900046491",
            primary_purchase_gtins: [],
            provider_text: "",
          },
          {
            primary_purchase_prefixed_code: ["PLU:radiansys.thecouponbureau.org:435796472"],
            lookupcodes: [],
            status: {
              locked: 1,
            },
            email_domain: "spectivlabs.thecouponbureau.org",
            store_coupon: 1,
            max_quantity_to_group: "1",
            primary_purchase_req_code: 0,
            save_value_code: 0,
            brand_id: "3de239b9",
            primary_purchase_requirements: 50,
            internal_id: "ae4143dc",
            settled: 0,
            is_included_in_gallery: false,
            settlement_email_sent: 0,
            primary_purchase_save_value: 1000,
            created_at: "2023-09-12T06:44:30.884Z",
            finalized: 0,
            executionId: "4d3269e1-3f23-49f3-981e-27a103c78d1e",
            allowed_retailers: [],
            free_quantity_type: "",
            offer_code: "453384",
            redemption_end_time: "2023-09-20",
            link: "https://gitsyv2app.page.link/EoRaiWXYk4rWajve6",
            access_type: "full_set_with_lock",
            description:
              "Get $10.00 off on minimum shopping of 50 units (ice cream 3) at your nearest store till 19th September 2023",
            campaign_metadata: {
              mobile_image_url:
                "https://gitsy-b2b-dev.s3.ap-south-1.amazonaws.com/01H6R1GGWD5HE1SSX4TKVYA106/product_image/1694500834867.depositphotos_256778368-stock-illustration-vector-cartoon-slush-icon-isolated.jpg",
              dollar_amount: 10,
              terms: "https://thecouponbureau.org/terms",
              desktop_image_url:
                "https://gitsy-b2b-dev.s3.ap-south-1.amazonaws.com/01H6R1GGWD5HE1SSX4TKVYA106/product_image/1694500834867.depositphotos_256778368-stock-illustration-vector-cartoon-slush-icon-isolated.jpg",
              allow_override: false,
              description:
                "Get $10.00 off on minimum shopping of 50 units (ice cream 3) at your nearest store till 19th September 2023",
              title: "Get $10.00 off",
            },
            rolling_expiration: 1,
            executedByEmail: "gitsyb2bapikeys_try@spectivlabs.thecouponbureau.org",
            brand_name: "Amul",
            total_circulation: 1000,
            campaign_start_time: "2023-09-12",
            create_date: "2023-09-12",
            campaign_end_time: "2023-09-20",
            donot_multiply_flag: 1,
            rolling_expiration_days: 7,
            max_limit_to_avail_offer: "Single",
            deposited: 0,
            update_datetime: 1694501069060,
            redemption_start_time: "2023-09-12",
            created_by_email_domain: "spectivlabs.thecouponbureau.org",
            approve_date: "2023-09-12",
            primary_purchase_eans: [],
            providers: ["spectivlabs.thecouponbureau.org", "radiansys.thecouponbureau.org"],
            enterprise_id: "01H6R1GGWD5HE1SSX4TKVYA106",
            manufacturer: "spectiv labs",
            timezone_val: "Pacific/Honolulu",
            base_gs1: "811200497900453384",
            primary_purchase_gtins: [],
            provider_text: "",
          },
          {
            lookupcodes: [],
            status: {
              locked: 1,
            },
            email_domain: "spectivlabs.thecouponbureau.org",
            store_coupon: 0,
            max_quantity_to_group: "1",
            primary_purchase_req_code: 0,
            save_value_code: 0,
            brand_id: "3de239b9",
            primary_purchase_requirements: 1,
            internal_id: "b7e753cb",
            settled: 0,
            is_included_in_gallery: true,
            settlement_email_sent: 0,
            primary_purchase_save_value: 199,
            created_at: "2023-09-29T11:25:33.716Z",
            finalized: 0,
            executionId: "a0330951-0e9d-4dc3-9e69-1d9fa3789de2",
            allowed_retailers: [],
            free_quantity_type: "",
            offer_code: "295647",
            redemption_end_time: "2023-10-13",
            link: "https://gitsyv2app.page.link/fKTncidGDsWMe5T69",
            access_type: "full_set_with_lock",
            description:
              "Save $1.99 on minimum shopping of 1 unit (Amul Pasteurised Butter) at your nearest store till 7th October 2023",
            campaign_metadata: {
              mobile_image_url:
                "https://gitsy-b2b-dev.s3.ap-south-1.amazonaws.com/01H6R1GGWD5HE1SSX4TKVYA106/product_image/1694519849926.95d868ed-6acd-4efc-990f-ee892ff3118d.__CR0%2C0%2C970%2C600_PT0_SX970_V1___.jpg",
              dollar_amount: 1.99,
              terms: "https://thecouponbureau.org/terms",
              desktop_image_url:
                "https://gitsy-b2b-dev.s3.ap-south-1.amazonaws.com/01H6R1GGWD5HE1SSX4TKVYA106/product_image/1694519849926.95d868ed-6acd-4efc-990f-ee892ff3118d.__CR0%2C0%2C970%2C600_PT0_SX970_V1___.jpg",
              allow_override: false,
              description:
                "Save $1.99 on minimum shopping of 1 unit (Amul Pasteurised Butter) at your nearest store till 7th October 2023",
              title: "Save $1.99 ",
            },
            rolling_expiration: 1,
            executedByEmail: "gitsyb2bapikeys_try@spectivlabs.thecouponbureau.org",
            brand_name: "Amul",
            total_circulation: 1000,
            campaign_start_time: "2023-09-29",
            create_date: "2023-09-29",
            campaign_end_time: "2023-10-07",
            donot_multiply_flag: 1,
            rolling_expiration_days: 7,
            max_limit_to_avail_offer: "Single",
            deposited: 0,
            update_datetime: 1695986732014,
            redemption_start_time: "2023-10-05",
            created_by_email_domain: "spectivlabs.thecouponbureau.org",
            approve_date: "2023-09-29",
            primary_purchase_eans: ["8901262010016"],
            providers: ["spectivlabs.thecouponbureau.org", "radiansys.thecouponbureau.org"],
            enterprise_id: "01H6R1GGWD5HE1SSX4TKVYA106",
            manufacturer: "spectiv labs",
            timezone_val: "Pacific/Honolulu",
            base_gs1: "811200497900295647",
            primary_purchase_gtins: [],
            provider_text: "",
          },
          {
            executedByEmail: "gitsyb2bapikeys_try@spectivlabs.thecouponbureau.org",
            lookupcodes: [],
            status: {
              locked: 1,
            },
            brand_name: "Amul",
            email_domain: "spectivlabs.thecouponbureau.org",
            store_coupon: 0,
            total_circulation: 1000,
            campaign_start_time: "2023-09-25",
            create_date: "2023-09-26",
            campaign_end_time: "2023-10-04",
            donot_multiply_flag: 1,
            max_quantity_to_group: "1",
            primary_purchase_req_code: 0,
            save_value_code: 0,
            brand_id: "3de239b9",
            primary_purchase_requirements: 20,
            max_limit_to_avail_offer: "Single",
            internal_id: "0aaacbca",
            settled: 0,
            deposited: 0,
            update_datetime: 1695711049943,
            is_included_in_gallery: false,
            settlement_email_sent: 0,
            primary_purchase_save_value: 2000,
            redemption_start_time: "2023-09-27",
            created_by_email_domain: "spectivlabs.thecouponbureau.org",
            approve_date: "2023-09-26",
            created_at: "2023-09-26T06:50:51.739Z",
            finalized: 0,
            executionId: "4298a14f-3fc1-4f77-bd06-69ba61de733d",
            primary_purchase_eans: ["8901262010016"],
            allowed_retailers: [],
            providers: ["spectivlabs.thecouponbureau.org", "radiansys.thecouponbureau.org"],
            enterprise_id: "01H6R1GGWD5HE1SSX4TKVYA106",
            free_quantity_type: "",
            offer_code: "742648",
            manufacturer: "spectiv labs",
            timezone_val: "Pacific/Honolulu",
            base_gs1: "811200497900742648",
            redemption_end_time: "2023-10-05",
            link: "https://gitsyv2app.page.link/gP2STT5Q9BKrfZ9z7",
            access_type: "full_set_with_lock",
            description:
              "Save $20.00 on minimum shopping of 20 units (Amul Pasteurised Butter) at your nearest store till 4th October 2023",
            primary_purchase_gtins: [""],
            campaign_metadata: {
              mobile_image_url:
                "https://gitsy-b2b-dev.s3.ap-south-1.amazonaws.com/01H6R1GGWD5HE1SSX4TKVYA106/product_image/1694519849926.95d868ed-6acd-4efc-990f-ee892ff3118d.__CR0%2C0%2C970%2C600_PT0_SX970_V1___.jpg",
              dollar_amount: 20,
              terms: "https://thecouponbureau.org/terms",
              desktop_image_url:
                "https://gitsy-b2b-dev.s3.ap-south-1.amazonaws.com/01H6R1GGWD5HE1SSX4TKVYA106/product_image/1694519849926.95d868ed-6acd-4efc-990f-ee892ff3118d.__CR0%2C0%2C970%2C600_PT0_SX970_V1___.jpg",
              allow_override: false,
              description:
                "Save $20.00 on minimum shopping of 20 units (Amul Pasteurised Butter) at your nearest store till 4th October 2023",
              title: "Save $20.00 ",
            },
            rolling_expiration: 0,
            provider_text: "",
          },
          {
            lookupcodes: [],
            status: {
              locked: 1,
            },
            email_domain: "spectivlabs.thecouponbureau.org",
            store_coupon: 0,
            max_quantity_to_group: "1",
            primary_purchase_req_code: 0,
            save_value_code: 0,
            brand_id: "3de239b9",
            primary_purchase_requirements: 10,
            internal_id: "5bd54f9b",
            settled: 0,
            is_included_in_gallery: false,
            settlement_email_sent: 0,
            primary_purchase_save_value: 1000,
            created_at: "2023-09-22T09:47:34.723Z",
            finalized: 0,
            executionId: "4e76123d-e68e-4b70-a6d9-5ca2eb3fb1a1",
            allowed_retailers: [],
            free_quantity_type: "",
            offer_code: "610366",
            redemption_end_time: "2023-09-30",
            link: "https://gitsyv2app.page.link/UUf1c4qsc2RY3rNj7",
            access_type: "full_set_with_lock",
            description:
              "Save $10.00 on minimum shopping of 10 units (Amul Pasteurised Butter) at your nearest store till 29th September 2023",
            campaign_metadata: {
              mobile_image_url:
                "https://gitsy-b2b-dev.s3.ap-south-1.amazonaws.com/01H6R1GGWD5HE1SSX4TKVYA106/product_image/1694519849926.95d868ed-6acd-4efc-990f-ee892ff3118d.__CR0%2C0%2C970%2C600_PT0_SX970_V1___.jpg",
              dollar_amount: 10,
              terms: "https://thecouponbureau.org/terms",
              desktop_image_url:
                "https://gitsy-b2b-dev.s3.ap-south-1.amazonaws.com/01H6R1GGWD5HE1SSX4TKVYA106/product_image/1694519849926.95d868ed-6acd-4efc-990f-ee892ff3118d.__CR0%2C0%2C970%2C600_PT0_SX970_V1___.jpg",
              allow_override: false,
              description:
                "Save $10.00 on minimum shopping of 10 units (Amul Pasteurised Butter) at your nearest store till 29th September 2023",
              title: "Save $10.00 ",
            },
            rolling_expiration: 1,
            executedByEmail: "gitsyb2bapikeys_try@spectivlabs.thecouponbureau.org",
            brand_name: "Amul",
            total_circulation: 1000,
            campaign_start_time: "2023-09-21",
            create_date: "2023-09-22",
            campaign_end_time: "2023-09-30",
            donot_multiply_flag: 1,
            rolling_expiration_days: 7,
            max_limit_to_avail_offer: "Single",
            deposited: 0,
            update_datetime: 1695376052967,
            redemption_start_time: "2023-09-21",
            created_by_email_domain: "spectivlabs.thecouponbureau.org",
            approve_date: "2023-09-22",
            primary_purchase_eans: ["8901262010016"],
            providers: ["spectivlabs.thecouponbureau.org", "radiansys.thecouponbureau.org"],
            enterprise_id: "01H6R1GGWD5HE1SSX4TKVYA106",
            manufacturer: "spectiv labs",
            timezone_val: "Pacific/Honolulu",
            base_gs1: "811200497900610366",
            primary_purchase_gtins: [],
            provider_text: "",
          },
        ],
        image_path:
          "https://gitsy-b2b-dev.s3.ap-south-1.amazonaws.com/01H6R1GGWD5HE1SSX4TKVYA106/gallery_image/1696938116430.95321dd548137885b6a0d090116a7036.jpg",
        enterprise_id: "01H6R1GGWD5HE1SSX4TKVYA106",
        link: "https://gitsyv2app.page.link/GSuHQgpGMyAwLSmHA",
        description: null,
        id: "01HCCP9HVYT5J3HW7WY3QKQR9A",
        name: "Amul Gallery",
      },
    ],
  },
  retailers: {
    data: [
      {
        internal_id: "d32eeaab",
        banner_image_url:
          "https://res.cloudinary.com/djptetycf/image/upload/<SCALE_PARAM>/v1684818138/Screenshot%202023-05-23%20at%2010.26.00%20AM.png",
        name: "Lowe's Market",
        email_domain: "lowesmarket.com",
        store_locator_url: "https://www2.lowesmarket.com/Storelocator/",
      },
      {
        internal_id: "a56e50b5",
        banner_image_url:
          "https://res.cloudinary.com/djptetycf/image/upload/<SCALE_PARAM>/v1684818270/udrnpxxg2jeemp3e1b3e.png",
        name: "Sparkle",
        email_domain: "sparkle-cs.com",
        store_locator_url: "https://example.com",
      },
      {
        internal_id: "caee1736",
        banner_image_url:
          "https://res.cloudinary.com/djptetycf/image/upload/<SCALE_PARAM>/v1684818138/Screenshot%202023-05-23%20at%2010.26.00%20AM.png",
        name: "aeon",
        email_domain: "aeon.catalinajapan",
        store_locator_url: "https://example.com",
      },
    ],
  },
};

export default Dummy;
